// Angielskie tlumaczenia tekstow tx('...') -- klucz = polski tekst z kodu.
// Brakujacy wpis = tekst polski. Parametry {0}, {1}... jak w kluczu.
const EN_TEXTS = {
  " (duplikaty: {0})": " (duplicates: {0})",
  "(Host: localhost, Port: 12345).": "(Host: localhost, Port: 12345).",
  "(albo lupka w nagłówku) — szybkie przejście do dowolnego widoku bez klikania po menu.": "(or the magnifier in the header) — jump quickly to any view without clicking through the menu.",
  "(baza MASTER.SCP nie jest wgrana — Panel admina → Kopie zapasowe)": "(the MASTER.SCP database is not uploaded — Admin panel → Backups)",
  "(czasem nazywaną \"XML Subscriber\") na koncie QRZ.com. Bez niej eksport zwróci błąd autoryzacji. Klucz Logbook API (inny niż klucz do wyszukiwania znaków!) znajdziesz na stronie swojego logbooka na QRZ.com, przycisk \"API Key\".": "(sometimes called \"XML Subscriber\") on your QRZ.com account. Without it the export returns an authorization error. The Logbook API key (different from the callsign lookup key!) is on your logbook page on QRZ.com, \"API Key\" button.",
  "(diagnostykę ma wersja 1.59.0 i nowsze) i sprawdź w hamlogger_agent.ini adres url i token.": "(diagnostics need version 1.59.0 or newer) and check the url and token in hamlogger_agent.ini.",
  "(domyślny, zgodny z konfiguracją)": "(default, matches the configuration)",
  "(komunikat w konsoli agenta) i czy zapora nie blokuje UDP.": "(message in the agent console) and whether a firewall blocks UDP.",
  "(potwierdzone: {0})": "(confirmed: {0})",
  "(przesuń na min. SWR)": "(move for min. SWR)",
  "(weryfikacja znaków SP w karcie stacji; odświeżany automatycznie co 7 dni):": "(SP callsign check in the station card; refreshed automatically every 7 days):",
  "(wymaga ustawionej częstotliwości sieci)": "(requires the net frequency to be set)",
  "(własne, po przecinku -- np. SSTV, pogawędka)": "(custom, comma separated -- e.g. SSTV, ragchew)",
  "(własny)": "(custom)",
  "(z historii)": "(from history)",
  "(zakładka Narzędzia → Egzamin UKE):": "(Tools → License exam tab):",
  "(zalogowany jako administrator:": "(logged in as administrator:",
  "(zapisane)": "(saved)",
  "(zapisany)": "(saved)",
  "(zapisany:": "(saved:",
  "(zrodlo chwilowo niedostepne)": "(source temporarily unavailable)",
  "(środek kraju)": "(centre of the country)",
  ") sam uruchamia i zarządza procesem rigctld (tak jak WSJT-X) -- nie trzeba go odpalać ręcznie w drugim okienku. Wymaga zainstalowanego Hamlib na komputerze, na którym działa agent.": ") starts and manages the rigctld process itself (just like WSJT-X) -- no need to run it manually in a second window. Requires Hamlib installed on the computer running the agent.",
  ") w prawym gornym rogu ekranu.": ") in the top right corner of the screen.",
  "), aby potwierdzić": ") to confirm",
  "**pogrubienie**": "**bold**",
  "+ Dodaj": "+ Add",
  "+ Utworz": "+ Create",
  "+ Zapisz nasłuch": "+ Save report",
  "+ Zgłoszenie": "+ Check-in",
  "+ dzień wcześniej. Przypomnienie przychodzi pushem i do dzwonka powiadomień.": "+ the day before. Reminders arrive as push notifications and in the notification bell.",
  ", błędy:": ", errors:",
  ", duplikaty:": ", duplicates:",
  ", jeszcze nie pobrany": ", not downloaded yet",
  ", ostatnio {0}": ", last {0}",
  ", w tym nowe kraje: {0}": ", including new countries: {0}",
  "- lista": "- list",
  "-- gdy pobierzesz z LoTW plik QSL-i (Download → QSLs, format ADIF), wgraj go tutaj, żeby oznaczyć potwierdzone QSO:": "-- when you download the QSL file from LoTW (Download → QSLs, ADIF format), upload it here to mark confirmed QSOs:",
  "-- otwórz pobrany plik": "-- open the downloaded file",
  "-- u Ciebie teraz": "-- your time now",
  "-- znaleziono": "-- found",
  ". Egzamin zdany, gdy zaliczysz wszystkie działy.": ". The exam is passed when you pass all sections.",
  ". Kafelki wybierzesz i ułożysz przyciskiem „Dostosuj”.": ". Pick and arrange tiles with the “Customize” button.",
  ". Spoty pochodzą z DX Clustera — jeśli lista jest pusta wszędzie, otwórz raz zakładkę DX Cluster.": ". Spots come from the DX Cluster — if the list is empty everywhere, open the DX Cluster tab once.",
  ". UKE zastrzega, że treść pytań na egzaminie może się różnić. W materiałach poprawna odpowiedź jest zaznaczona tylko przy części pytań — tu trafiają wyłącznie pytania z kluczem, także te z rysunkiem (schemat wycięty z materiałów UKE).": ". UKE notes that the exam questions may differ. In the materials the correct answer is marked only for some questions — only questions with a key are used here, including those with a figure (diagram cut from the UKE materials).",
  ". UKE zastrzega, że treść pytań na egzaminie może się różnić. W materiałach poprawna odpowiedź jest zaznaczona tylko przy części pytań, a pytania z rysunkami wymagają schematu — tu trafiają wyłącznie pytania z kluczem i bez rysunku.": ". UKE notes that the exam questions may differ. In the materials the correct answer is marked only for some questions, and questions with drawings need a diagram — only questions with an answer key and no drawing are included here.",
  ". Wybierz profil w loggerze i zrób kilka łączności.": ". Choose a profile in the logger and make a few QSOs.",
  "1 z {0}": "1 of {0}",
  "1. Na swoim serwerze Discord: Ustawienia kanalu → Integracje → Webhooki → Nowy webhook": "1. On your Discord server: Channel settings → Integrations → Webhooks → New webhook",
  "1. Napisz do": "1. Message",
  "1. Słyszana stacja": "1. Heard station",
  "1. Znak korespondenta": "1. The other station’s callsign",
  "1. dnia miesiąca: liczba QSO, nowe kraje i użyte pasma za miniony miesiąc; 1 stycznia także podsumowanie całego roku.": "1st of the month: QSO count, new countries and bands used in the past month; on January 1st also a summary of the whole year.",
  "2. Admin wpisuje token w panelu Admin → Ustawienia (albo zmiennej": "2. The admin enters the token in Admin panel → Settings (or the variable",
  "2. Data i godzina (UTC)": "2. Date and time (UTC)",
  "2. Skopiuj URL webhooka i wklej w pole powyzej": "2. Copy the webhook URL and paste it in the field above",
  "2. Z kim pracowała": "2. Who it worked",
  "3. Częstotliwość i emisja": "3. Frequency and mode",
  "3. Emisja": "3. Mode",
  "3. Gotowe -- bez dodatkowej konfiguracji, alerty pojawia się automatycznie jako \"embed\"": "3. Done -- no extra configuration, alerts appear automatically as an \"embed\"",
  "3. Napisz /start do swojego bota i wpisz swoje Chat ID w ustawieniach profilu": "3. Send /start to your bot and enter your Chat ID in the profile settings",
  "4. Alerty będą wysylane automatycznie gdy HamLogger znajdzie spot z watchlisty": "4. Alerts will be sent automatically when HamLogger finds a spot from your watchlist",
  "4. Częstotliwość": "4. Frequency",
  "4. Raport": "4. Report",
  "5. Raport (RST)": "5. Report (RST)",
  "5. Zapisz nasłuch": "5. Save the report",
  "599 100W albo 599 CA": "599 100W or 599 CA",
  "6. Zapisz": "6. Save",
  "73 / wolny tekst": "73 / free text",
  ": sekcja": ": section",
  "; zapis do pliku:": "; logging to a file:",
  "ADIF (zaznaczone)": "ADIF (selected)",
  "ARRL DX (RST + moc/stan)": "ARRL DX (RST + power/state)",
  "ARRL SS (numer + prec. + sekcja + rok lic.)": "ARRL SS (number + prec. + section + check)",
  "Adres": "Address",
  "Adres CI-V": "CI-V address",
  "Adres Twojego Wavelog/Cloudlog, klucz API z prawem zapisu (Konto → API Keys) i ID profilu stacji (Station Locations).": "The address of your Wavelog/Cloudlog, an API key with write access (Account → API Keys) and the station profile ID (Station Locations).",
  "Adres Wavelog/Cloudlog": "Wavelog/Cloudlog address",
  "Adres e-mail": "Email address",
  "Adres email (opcjonalnie -- jeśli QRZ nie ma publicznego)": "E-mail address (optional -- if QRZ has no public one)",
  "Adres email zostal potwierdzony!": "E-mail address confirmed!",
  "Adres w sieci lokalnej (np. 10.x/192.168.x) może ustawić tylko administrator serwera.": "A local network address (e.g. 10.x/192.168.x) can only be set by the server administrator.",
  "Adres webhooka, na który HamLogger wysyła alerty DX (watchlista, reguły alertów).": "Webhook address where HamLogger sends DX alerts (watchlist, alert rules).",
  "Agent HamLogger (WSJT-X + CAT)": "HamLogger agent (WSJT-X + CAT)",
  "Agent nasłuchuje na UDP {0}, ale nic nie przyszło.": "The agent listens on UDP {0}, but nothing has arrived.",
  "Agent nie ma połączenia CAT — spróbuje rigctld na localhost:4532": "The agent has no CAT connection — it will try rigctld on localhost:4532",
  "Agent nie potwierdził wykonania polecenia w 15 s — sprawdź, czy agent działa (Narzędzia → Diagnostyka agenta).": "The agent did not confirm the command within 15 s — check that the agent is running (Tools → Agent diagnostics).",
  "Agent nie przesyła diagnostyki": "The agent is not sending diagnostics",
  "Agent online · {0}": "Agent online · {0}",
  "Agent połączony z HamLoggerem": "Agent connected to HamLogger",
  "Akcesoria": "Accessories",
  "Akcja dyplomowa: {0}": "Award activity: {0}",
  "Akcja dyplomowa: {0} (otworz w nowej karcie)": "Award activity: {0} (open in a new tab)",
  "Aktualizacja {0}": "Updated {0}",
  "Aktualizacje na zywo dla wszystkich operatorow": "Live updates for all operators",
  "Aktualne hasło": "Current password",
  "Aktualnie:": "Currently:",
  "Aktualny czas UTC (do logowania QSO)": "Current UTC time (for logging QSOs)",
  "Aktywacja ważna — pracuj dalej ile chcesz.": "Activation is valid — keep going as long as you like.",
  "Aktywacja {0}": "Activation {0}",
  "Aktywator": "Activator",
  "Aktywatorzy": "Activators",
  "Aktywni aktywatorzy": "Active activators",
  "Aktywny teraz": "Active now",
  "Alerty 24 h": "Alerts 24 h",
  "Ameryka Południowa": "South America",
  "Ameryka Północna": "North America",
  "Analiza czasowa": "Time analysis",
  "Antena": "Antenna",
  "Anteny": "Antennas",
  "Anulować zaproszenie dla {0}?": "Cancel the invitation for {0}?",
  "Anuluj": "Cancel",
  "Anuluj edycję": "Cancel editing",
  "Audio (w paśmie)": "Audio (in passband)",
  "Austria": "Austria",
  "Auto-numeracja": "Auto-numbering",
  "Automatyczna wysyłka wyłączona": "Automatic upload off",
  "Automatycznie co 6 h": "Automatically every 6 h",
  "Azymut": "Azimuth",
  "Azymut musi być w zakresie 0-360°": "Azimuth must be between 0 and 360°",
  "Azymut: {0}°": "Azimuth: {0}°",
  "Baza Super Check Partial (zawody)": "Super Check Partial database (contests)",
  "Baza nie jest jeszcze wgrana.": "The database has not been uploaded yet.",
  "Baza pytań nie jest jeszcze wgrana — administrator robi to jednym przyciskiem w Panel admina → Kopie zapasowe.": "The question bank has not been uploaded yet — the administrator does it with one button in Admin panel → Backups.",
  "Belgia": "Belgium",
  "Bez parku QSO zapiszą się normalnie (praca portable). Z parkiem — liczy się aktywacja POTA.": "Without a park, QSOs are logged normally (portable operation). With a park, they count towards a POTA activation.",
  "Bezchmurnie": "Clear sky",
  "Bezpieczeństwo": "Security",
  "Biorę udział w rankingu (mój znak i wyniki będą widoczne dla innych użytkowników HamLoggera)": "I take part in the ranking (my callsign and results will be visible to other HamLogger users)",
  "Biorę udział w rankingu HamLoggera": "I take part in the HamLogger ranking",
  "Blad": "Error",
  "Blad importu": "Import error",
  "Blad logowania QRZ": "QRZ login error",
  "Blad polaczenia": "Connection error",
  "Blad resetowania hasla": "Password reset error",
  "Blad sledzenia satelity": "Satellite tracking error",
  "Blad synchronizacji": "Sync error",
  "Blad usuwania certyfikatu": "Error deleting certificate",
  "Blad weryfikacji": "Verification error",
  "Blad wysylki": "Send error",
  "Blad wysylki eQSL": "eQSL send error",
  "Blad wysylki komendy QSY": "Error sending QSY command",
  "Blad zapisu ustawien": "Error saving settings",
  "Blad zapisu webhooka": "Error saving webhook",
  "Boczne menu można zwinąć do ikon (przycisk na dole menu), a pozycje przypiąć na górze (pinezka po najechaniu). Na telefonie zawsze są dolne zakładki.": "The side menu can be collapsed to icons (button at the bottom of the menu) and items can be pinned to the top (pin on hover). On phones there are always bottom tabs.",
  "Boczne, z lewej": "Side, left",
  "Boczne, z prawej": "Side, right",
  "Brak": "None",
  "Brak QSO w": "No QSOs in",
  "Brak QSO w tym dzienniku": "No QSOs in this logbook",
  "Brak QSO z zapisanym sprzętem": "No QSOs with saved equipment",
  "Brak QSO.": "No QSOs.",
  "Brak agenta z obrotnicą": "No agent with a rotator",
  "Brak aktywnych aktywacji": "No active activations",
  "Brak aktywnych spotów w ostatnich 30 minutach": "No active spots in the last 30 minutes",
  "Brak burzy w prognozie/ostrzezeniach na najblizsze 6h": "No storm in the forecast/warnings for the next 6 h",
  "Brak czestotliwosci": "No frequency",
  "Brak danych QRZ": "No QRZ data",
  "Brak danych do analizy": "No data to analyse",
  "Brak danych o propagacji.": "No propagation data.",
  "Brak danych z bazy znaków (zaloguj QRZ albo dodaj konto HamQTH w Ustawienia → API).": "No data from the callsign database (log in to QRZ or add a HamQTH account in Settings → Integrations).",
  "Brak danych.": "No data.",
  "Brak danych. Kliknij \"Synchronizuj teraz\" aby pobrać aktualne akcje z radiodyplom.pl": "No data. Click \"Sync now\" to fetch current activities from radiodyplom.pl",
  "Brak dekodów": "No decodes",
  "Brak dostepu do mikrofonu:": "No microphone access:",
  "Brak dostępu do mikrofonu": "No microphone access",
  "Brak krajów": "No countries",
  "Brak nagrania": "No recording",
  "Brak nagrania dla tego klawisza": "No recording for this key",
  "Brak nasłuchów — dodaj pierwszy powyżej.": "No SWL reports — add the first one above.",
  "Brak nowych potwierdzeń w LoTW.": "No new confirmations in LoTW.",
  "Brak nowych stacji wołających CQ": "No new stations calling CQ",
  "Brak ogłoszeń": "No listings",
  "Brak operatorow w zasiegu": "No operators in range",
  "Brak pakietów z WSJT-X": "No packets from WSJT-X",
  "Brak połączenia z internetem — aplikacja działa offline": "No internet connection — the app works offline",
  "Brak przemienników": "No repeaters",
  "Brak pytań": "No questions",
  "Brak pytań, w których się mylisz — świetnie!": "No questions you get wrong — great!",
  "Brak rozmów.": "No conversations.",
  "Brak sesji.": "No sessions.",
  "Brak spotów na": "No spots on",
  "Brak ulubionych -- dodaj swój pierwszy przemiennik powyżej": "No favourites -- add your first repeater above",
  "Brak umówionych łączności.": "No scheduled QSOs.",
  "Brak wpisów": "No entries",
  "Brak wspolnych dziennikow -- utworz nowy lub dolacz przez kod": "No shared logbooks -- create a new one or join with a code",
  "Brak wspolrzednych/lokatora stacji do oceny trasy": "No station coordinates/locator to assess the path",
  "Brak zaplanowanych skedów.": "No skeds scheduled.",
  "Brak zawodów w najbliższych dniach.": "No contests in the coming days.",
  "Brak zdarzeń.": "No events.",
  "Brak zgody na lokalizację — zezwól w ustawieniach przeglądarki.": "Location permission denied — allow it in your browser settings.",
  "Brak zgłoszeń.": "No check-ins.",
  "Brakujące": "Missing",
  "Buenos Aires, Argentyna": "Buenos Aires, Argentina",
  "Burza": "Thunderstorm",
  "Burza geomagnetyczna (Kp ≥ 5): słabsze KF, szansa na zorzę na 6 m / 2 m": "Geomagnetic storm (Kp ≥ 5): weaker HF, a chance of aurora on 6 m / 2 m",
  "Burza w okolicy stacji (ostrzeżenia IMGW i prognoza na 6 h)": "Thunderstorm near your station (IMGW warnings and 6 h forecast)",
  "Burza z gradem (silny)": "Thunderstorm with hail (heavy)",
  "Burza z gradem (slaby)": "Thunderstorm with hail (light)",
  "Bądź uprzejmy — moderatorzy mogą usuwać wiadomości. Nie podawaj tu danych osobowych innych osób.": "Be polite — moderators can delete messages. Do not post other people's personal data here.",
  "BŁĄD": "ERROR",
  "Błąd": "Error",
  "Błąd QRZ": "QRZ error",
  "Błąd edycji masowej": "Bulk edit error",
  "Błąd eksportu": "Export error",
  "Błąd generowania tokenu": "Error generating token",
  "Błąd importu": "Import error",
  "Błąd importu ADIF": "ADIF import error",
  "Błąd importu Cabrillo": "Cabrillo import error",
  "Błąd oceny": "Grading error",
  "Błąd oceny propagacji": "Propagation assessment error",
  "Błąd pobierania": "Download error",
  "Błąd pobierania danych": "Error fetching data",
  "Błąd pobierania danych propagacyjnych -- spróbuj ponownie.": "Error fetching propagation data -- try again.",
  "Błąd pobierania konfiguracji": "Error fetching configuration",
  "Błąd pobierania logbook": "Error fetching logbook",
  "Błąd pobierania pliku": "Error downloading file",
  "Błąd pobierania przemienników": "Error fetching repeaters",
  "Błąd połączenia z backendem HamLoggera": "Error connecting to the HamLogger backend",
  "Błąd rozpoznawania glosu": "Speech recognition error",
  "Błąd startu eksportu": "Error starting export",
  "Błąd tworzenia dziennika": "Error creating the logbook",
  "Błąd usuwania": "Delete error",
  "Błąd usuwania masowego": "Bulk delete error",
  "Błąd uzupelniania danych z QRZ": "Error filling in data from QRZ",
  "Błąd wgrywania": "Upload error",
  "Błąd wylaczania powiadomien": "Error turning off notifications",
  "Błąd wysyłki": "Send error",
  "Błąd wysyłki CW": "CW send error",
  "Błąd wysyłki do LoTW": "Error sending to LoTW",
  "Błąd wysyłki do Wavelog": "Error sending to Wavelog",
  "Błąd wysyłki eQSL": "eQSL send error",
  "Błąd wysyłki komendy obrotu": "Error sending rotate command",
  "Błąd wysyłki komendy rotora": "Error sending rotator command",
  "Błąd wyszukiwania": "Search error",
  "Błąd zapisu": "Save error",
  "Błąd zapisu emaila": "Error saving e-mail",
  "Błąd zapisu lokalizacji": "Error saving location",
  "Błąd zapisu offline (IndexedDB niedostepne w tej przeglądarce)": "Offline save error (IndexedDB not available in this browser)",
  "Błąd zapisu sieci": "Error saving the net",
  "Błąd zapisu ulubionych częstotliwości": "Error saving favourite frequencies",
  "Błąd zapisu ustawienia auto-uploadu": "Error saving auto-upload setting",
  "Błąd zapisu webhooka": "Error saving webhook",
  "Błąd zapisu zgłoszenia": "Error saving the check-in",
  "Błąd zdjęcia": "Photo error",
  "Błąd zmiany hasła": "Error changing password",
  "Błąd {0}": "Error {0}",
  "Błąd ładowania": "Loading error",
  "Błąd ładowania QSO": "Error loading QSOs",
  "Błąd ładowania giełdy": "Error loading the gear market",
  "Błąd ładowania karty stacji": "Error loading the station card",
  "Błąd ładowania krajów DXCC": "Error loading DXCC countries",
  "Błąd ładowania podsumowania": "Error loading the summary",
  "Błąd ładowania rankingu": "Error loading the ranking",
  "Błąd ładowania regulaminu.": "Error loading the terms of service.",
  "Błąd ładowania reguł": "Error loading rules",
  "Błąd ładowania sieci": "Error loading nets",
  "Błąd ładowania tabeli DXCC": "Error loading the DXCC table",
  "Błąd ładowania zdarzeń": "Error loading events",
  "Błędy połączenia z HamLoggerem: {0}": "Connection errors to HamLogger: {0}",
  "CAT jest opcjonalny -- jeśli nie skonfigurujesz radia, ta część po prostu się wyłączy bez błędu": "CAT is optional -- if you don't configure a radio, this part simply turns off without errors",
  "COM3 albo /dev/ttyUSB0": "COM3 or /dev/ttyUSB0",
  "COM4 albo /dev/ttyUSB1": "COM4 or /dev/ttyUSB1",
  "CQ WPX (RST + numer)": "CQ WPX (RST + serial)",
  "CQ WW (RST + strefa CQ)": "CQ WW (RST + CQ zone)",
  "CW (keyer radia)": "CW (radio keyer)",
  "Caracas, Wenezuela": "Caracas, Venezuela",
  "Cała mapa, północ u góry": "Whole map, north up",
  "Cele i odznaki": "Goals & badges",
  "Cena (zł)": "Price (PLN)",
  "Certyfikat LoTW usuniety": "LoTW certificate deleted",
  "Certyfikat LoTW zaimportowany!": "LoTW certificate imported!",
  "Certyfikat stacji (.tq6)": "Station certificate (.tq6)",
  "Certyfikat stacji (.tq6) z lotw.arrl.org służy do wysyłki QSO — wgrywasz go raz. Login i hasło do strony lotw.arrl.org (opcjonalnie) pozwalają co 6 godzin pobierać nowe potwierdzenia. Wszystko jest szyfrowane na serwerze.": "The station certificate (.tq6) from lotw.arrl.org is used to upload QSOs — you upload it once. Your lotw.arrl.org website login and password (optional) let HamLogger download new confirmations every 6 hours. Everything is encrypted on the server.",
  "Certyfikat stacji (.tq6) z lotw.arrl.org — wgrywasz go raz. Hasło i certyfikat są szyfrowane na serwerze.": "Station certificate (.tq6) from lotw.arrl.org — you upload it once. The password and certificate are encrypted on the server.",
  "Chroma": "Chroma",
  "Ciemna (domyślna)": "Dark (default)",
  "Ciemny": "Dark",
  "Cisza na czacie.": "The chat is quiet.",
  "Cisza od (UTC)": "Quiet from (UTC)",
  "Cisza w eterze… napisz pierwszy! (np. „QRV na 145.500 za 10 min?”)": "Radio silence… be the first to write! (e.g. “QRV on 145.500 in 10 min?”)",
  "ClubLog odpowiedzialo bledem -- sprawdź API key": "ClubLog returned an error -- check the API key",
  "Co pokazywać innym:": "What to show others:",
  "Co teraz robić?": "What to do now?",
  "Co widzi agent HamLoggera na komputerze przy radiu: pakiety z WSJT-X, wysłane polecenia, stan CAT i błędy. Szczegółowy podgląd w konsoli agenta włączysz w": "What the HamLogger agent sees on the radio PC: WSJT-X packets, commands sent, CAT state and errors. Turn on detailed output in the agent console in",
  "Co widzisz zaraz po zalogowaniu.": "What you see right after logging in.",
  "Coś poszło nie tak podczas wyświetlania. Twoje dane są bezpieczne — spróbuj odświeżyć stronę albo wróć do loggera.": "Something went wrong while displaying this. Your data is safe — try refreshing the page or go back to the logger.",
  "Ctrl+Enter zapisuje · Esc czyści": "Ctrl+Enter saves · Esc clears",
  "Cyfrowe": "Digital",
  "Czas": "Time",
  "Czas UTC (puste = teraz)": "UTC time (empty = now)",
  "Czas lokalny ~": "Local time ~",
  "Czat": "Chat",
  "Cze": "Jun",
  "Czechy": "Czechia",
  "Czesciowe zachmurzenie": "Partly cloudy",
  "Czestotliwosc poza pasmami amatorskimi -- sprawdz": "Frequency outside the amateur bands -- check it",
  "Czlonkowie": "Members",
  "Czw": "Thu",
  "Czy WSJT-X nadal działa?": "Is WSJT-X still running?",
  "Czy jestem w Twoim logu?": "Am I in your log?",
  "Czy jestem w logu? Wpisz swój znak.": "Am I in the log? Enter your callsign.",
  "Czyści cache przeglądarki i pobiera najnowszą wersję aplikacji": "Clears the browser cache and downloads the latest version of the app",
  "Częst.": "Freq.",
  "Częstotliwość": "Frequency",
  "Częstotliwość (MHz)": "Frequency (MHz)",
  "Częstotliwość w MHz, np. 14.205, a obok emisja: SSB — głos, CW — telegrafia, FT8 — tryb cyfrowy.": "Frequency in MHz, e.g. 14.205, and next to it the mode: SSB — voice, CW — telegraphy, FT8 — a digital mode.",
  "Części": "Parts",
  "Część aplikacji zmieniła się na serwerze. Odśwież stronę, żeby wczytać aktualną wersję.": "Part of the app has changed on the server. Refresh the page to load the current version.",
  "DELTA LOOP PEŁNOFALOWA — schemat techniczny (widok boczny)": "FULL-WAVE DELTA LOOP — technical drawing (side view)",
  "DIPOL PÓŁFALOWY — schemat techniczny (widok boczny)": "HALF-WAVE DIPOLE — technical drawing (side view)",
  "Dalej": "Next",
  "Dalej →": "Next →",
  "Dane logowania i klucze API do QRZ Logbook, eQSL, ClubLog, LoTW, HRDLOG i Wavelog są w zakładce „Serwisy QSO”.": "Login details and API keys for QRZ Logbook, eQSL, ClubLog, LoTW, HRDLOG and Wavelog are in the “QSO services” tab.",
  "Dane z UKE": "UKE data",
  "Dane z pamieci podrecznej (odswiezane co 5 min, zeby nie obciazac zrodla)": "Cached data (refreshed every 5 min so as not to overload the source)",
  "Dane: Club Log Most Wanted (publiczne). Ranking odświeżany rzadko (cache 24h).": "Data: Club Log Most Wanted (public). The ranking is refreshed rarely (24h cache).",
  "Darmowy klucz: developer.tomtom.com (Map Display API). Klucz jest używany w przeglądarkach użytkowników — w panelu TomTom ogranicz go do domeny HamLoggera.": "Free key: developer.tomtom.com (Map Display API). The key is used in users' browsers — restrict it to the HamLogger domain in the TomTom dashboard.",
  "Data": "Date",
  "Data (UTC)": "Date (UTC)",
  "Data i godzina (UTC)": "Date and time (UTC)",
  "Data/Czas": "Date/Time",
  "Data/czas (UTC)": "Date/time (UTC)",
  "Dekoder CW (beta)": "CW decoder (beta)",
  "Dekoder CW (beta) -- nasluchuje mikrofonu": "CW decoder (beta) -- listens to the microphone",
  "Dekodowanie": "Decoding",
  "Dekoduj": "Decode",
  "Dekoduj ponownie (Alt+D)": "Decode again (Alt+D)",
  "Dekody": "Decodes",
  "Dekody WSPR": "WSPR decodes",
  "Dekody docierają": "Decodes are arriving",
  "Deszcz": "Rain",
  "Deszcz intensywny": "Heavy rain",
  "Deszcz marznacy": "Freezing rain",
  "Deszcz marznacy intensywny": "Heavy freezing rain",
  "Deszcz slaby": "Light rain",
  "Diagnostyka": "Diagnostics",
  "Diagnostyka agenta": "Agent diagnostics",
  "Direktor": "Director",
  "Dla dopasowania aktywacji POTA możesz użyć wildcarda -- np. SP* złapie SP1ABC, SP3DCD itd. Dopasowanie w klastrze DX pozostaje dokładne (bez wildcarda).": "For POTA activation matching you can use a wildcard -- e.g. SP* catches SP1ABC, SP3DCD etc. DX cluster matching stays exact (no wildcard).",
  "Dla pojedynczego QSO zawsze możesz to odznaczyć. Wygląd karty eQSL edytujesz w widoku „Projekt eQSL”.": "You can always untick it for a single QSO. You edit the eQSL card design in the “eQSL design” view.",
  "Do loggera": "To the logger",
  "Dodaj": "Add",
  "Dodaj do logu": "Add to log",
  "Dodaj ogłoszenie": "Add listing",
  "Dodaj profil sprzętu": "Add equipment profile",
  "Dodaj sked": "Add sked",
  "Dodaj zaznaczone do kolejki QSL papierowych": "Add selected to the paper QSL queue",
  "Dodano {0} QSO do kolejki QSL": "Added {0} QSOs to the QSL queue",
  "Dodatkowe: efektowne": "Extra: flashy",
  "Dodatkowe: klimatyczne": "Extra: atmospheric",
  "Dodatkowe: retro": "Extra: retro",
  "Dodatkowe: stonowane": "Extra: muted",
  "Dolacz": "Join",
  "Dolaczono do \"{0}\"!": "Joined \"{0}\"!",
  "Domyslny QTH nickname z konta eQSL": "Default QTH nickname from the eQSL account",
  "Domyślne wyjście systemu": "System default output",
  "Domyślnie eksportowane są tylko": "By default only",
  "Domyślnie nasłuchuje na": "By default it listens on",
  "Domyślnie zaznaczaj „Wyślij eQSL” przy nowym QSO": "Tick “Send eQSL” by default for a new QSO",
  "Dostaniesz azymut i elewację (gdzie skierować antenę), wykres nieba ze śladem przelotu oraz ślad naziemny satelity na mapie.": "You will get the azimuth and elevation (where to point the antenna), a sky plot with the pass track and the satellite's ground track on the map.",
  "Dostosuj": "Customize",
  "Dostępna jest nowa wersja HamLoggera": "A new version of HamLogger is available",
  "Dostępne:": "Available:",
  "Dołącz przez kod zaproszenia": "Join with an invitation code",
  "Druk w rozmiarze karty QSL (140 × 90 mm). PDF: arkusz A4 z liniami cięcia. Wygląd karty zmienisz w edytorze szablonu (ten sam co dla eQSL).": "Prints at QSL card size (140 × 90 mm). PDF: an A4 sheet with cut marks. Change the card design in the template editor (the same one as for eQSL).",
  "Drukuj": "Print",
  "Dyplomy": "Awards",
  "Dział": "Section",
  "Dziennik": "Logbook",
  "Dziennik \"{0}\" utworzony! Kod zaproszenia: {1}": "Logbook \"{0}\" created! Invitation code: {1}",
  "Dziennik jest pusty — pierwsze QSO dodasz w Loggerze.": "The logbook is empty — add your first QSO in the Logger.",
  "Dziennik na żywo": "Live log",
  "Dziennik nasłuchowca — kogo słyszałeś, z kim pracował i jaki raport mu dajesz. Wpisy są osobno od QSO (nie liczą się do statystyk ani dyplomów). Eksport ADIF ma znacznik": "Listener's log — who you heard, who they worked and what report you give them. Entries are kept separate from QSOs (they don't count towards statistics or awards). The ADIF export has the flag",
  "Dziennik nasłuchów na pierwszym miejscu": "Listening log comes first",
  "Dziennik łączności krotkofalarskiej": "Amateur radio logbook",
  "Długa droga:": "Long path:",
  "Edytuj": "Edit",
  "Edytuj QSO — {0}": "Edit QSO — {0}",
  "Edytuj ogłoszenie": "Edit listing",
  "Edytuj szablon": "Edit template",
  "Egzamin na świadectwo": "Certificate exam",
  "Egzamin próbny": "Practice exam",
  "Ekran nie gaśnie": "Screen stays on",
  "Ekran startowy": "Start screen",
  "Ekskluzywne (Youtuber)": "Exclusive (YouTuber)",
  "Eksperymentalne -- jakość zależy od czystości sygnalu z głośnika radia. Najlepiej działa przy stabilnym tempie i niskim szumie tla.": "Experimental -- quality depends on how clean the signal from the radio speaker is. Works best with a steady speed and low background noise.",
  "Eksport (wszystkie QSO) wystartował w tle": "Export (all QSOs) started in the background",
  "Eksport ADIF": "ADIF export",
  "Eksport CSV": "Export CSV",
  "Eksport Cabrillo": "Cabrillo export",
  "Eksport nowych QSO wystartował w tle": "Export of new QSOs started in the background",
  "El. napędowy": "Driven el.",
  "Elewacja": "Elevation",
  "Email": "E-mail",
  "Email ClubLog": "ClubLog e-mail",
  "Email zmieniony -- wysłano link weryfikacyjny na nowy adres": "E-mail changed -- a verification link was sent to the new address",
  "Emisja": "Mode",
  "Emisje": "Modes",
  "Emisje (nic = wszystkie)": "Modes (none = all)",
  "Enable TX (Alt+N w WSJT-X)": "Enable TX (Alt+N in WSJT-X)",
  "Enable TX, Tune, Monitor, Log QSO i Tx1–6 wymagają agenta 1.61+ na Windows — protokół WSJT-X ich nie ma, agent używa skrótów klawiszowych WSJT-X.": "Enable TX, Tune, Monitor, Log QSO and Tx1–6 require agent 1.61+ on Windows — the WSJT-X protocol lacks them, so the agent uses WSJT-X keyboard shortcuts.",
  "Enable TX, Tune, Monitor, Log QSO i Tx1–6 wymagają agenta 1.62+ na Windows — protokół WSJT-X ich nie ma, agent używa skrótów klawiszowych WSJT-X.": "Enable TX, Tune, Monitor, Log QSO and Tx1–6 require agent 1.62+ on Windows — the WSJT-X protocol lacks them, so the agent uses WSJT-X keyboard shortcuts.",
  "Enable TX: wył.": "Enable TX: off",
  "Enable TX: wł.": "Enable TX: on",
  "Esc — przerwij QSO i nadawanie": "Esc — abort QSO and transmission",
  "Eureka, Kanada": "Eureka, Canada",
  "FM na KF zalecane tylko w 29.0–29.7 MHz (plan IARU R1).": "FM on HF is recommended only in 29.0–29.7 MHz (IARU R1 band plan).",
  "Field Day (klasa + sekcja)": "Field Day (class + section)",
  "Filtry i wygląd": "Filters and appearance",
  "Fonia": "Phone",
  "Fonia (nagrania)": "Phone (recordings)",
  "Fonia: wyjście audio komputera → wejście audio radia (np. interfejs USB); nadawanie przez VOX albo PTT. CW: agent HamLoggera wysyła tekst do rigctld (Hamlib „send_morse”) — działa z radiami, których sterownik to obsługuje (m.in. wiele ICOM i Kenwood). Nagrania zostają w tej przeglądarce.": "Phone: computer audio output → radio audio input (e.g. a USB interface); transmit via VOX or PTT. CW: the HamLogger agent sends text to rigctld (Hamlib “send_morse”) — works with radios whose driver supports it (incl. many ICOM and Kenwood). Recordings stay in this browser.",
  "Francja": "France",
  "Funkcja testowa": "Test feature",
  "Gdy wrócisz do zasięgu, wyślij QSO z kolejki offline (baner na dole ekranu).": "When you are back in coverage, send the QSOs from the offline queue (banner at the bottom of the screen).",
  "Gdy wysyłka się nie uda, dostaniesz powiadomienie (push i e-mail), a kolejne próby będą nie częściej niż co godzinę.": "If an upload fails you will be notified (push and e-mail), and further attempts will happen at most once an hour.",
  "Gdy znak lub kraj pojawi się w klastrze DX (w tym RBN), albo obserwowany znak aktywuje park POTA — dostaniesz powiadomienie. Dla POTA możesz też wpisać prefiks z gwiazdką (np. SP*), żeby złapać dowolny znak zaczynający się tak jak podałeś.": "When a callsign or country shows up in the DX cluster (including RBN), or a watched callsign activates a POTA park — you get a notification. For POTA you can also enter a prefix with an asterisk (e.g. SP*) to catch any callsign starting like that.",
  "Gdzie": "Where",
  "Generuję kartę…": "Generating the card…",
  "Giełda sprzętu": "Gear market",
  "Gotowe": "Done",
  "Gotowe — 73!": "All set — 73!",
  "Gotowe. Lista nasłuchów jest pod formularzem — możesz ją przeszukiwać i eksportować (ADIF).": "Done. The list of your reports is below the form — you can search it and export it (ADIF).",
  "Granulki sniegu": "Snow grains",
  "Grayline": "Grayline",
  "GridTrackera/JTAlerta, ustaw adres multicast (np. 224.0.0.1) albo przekazywanie pakietów. Sprawdź, czy port nie jest zajęty": "GridTracker/JTAlert, set a multicast address (e.g. 224.0.0.1) or packet forwarding. Check whether the port is already in use",
  "Gru": "Dec",
  "Główne": "Main",
  "HRDLOG odpowiedzialo bledem: {0}": "HRDLOG returned an error: {0}",
  "HRDLOG.net to publiczny, przeszukiwalny log online (przydatny np. w pileupach -- inni operatorzy moga sprawdzic \"czy już mnie pracowales\"). API key znajdziesz w ustawieniach swojego konta na hrdlog.net.": "HRDLOG.net is a public, searchable online log (useful e.g. in pileups -- other operators can check \"have you worked me already\"). You'll find the API key in your account settings on hrdlog.net.",
  "HamLogger nie dostał jeszcze żadnych danych diagnostycznych.": "HamLogger has not received any diagnostic data yet.",
  "HamQTH połączone": "HamQTH connected",
  "HamQTH — darmowa baza znaków": "HamQTH — free callsign database",
  "Hasla nie sa identyczne": "Passwords do not match",
  "Haslo musi miec min. 6 znakow": "Password must be at least 6 characters",
  "Haslo nadane przy pobieraniu certyfikatu z LoTW": "Password set when downloading the certificate from LoTW",
  "Hasło": "Password",
  "Hasło ClubLog": "ClubLog password",
  "Hasło HamQTH": "HamQTH password",
  "Hasło QRZ.com": "QRZ.com password",
  "Hasło certyfikatu": "Certificate password",
  "Hasło do lotw.arrl.org": "lotw.arrl.org password",
  "Hasło eQSL": "eQSL password",
  "Hasło zmienione! Inne sesje zostaly wylogowane.": "Password changed! Other sessions have been logged out.",
  "Heartbeat (WSJT-X żyje)": "Heartbeat (WSJT-X alive)",
  "Hiszpania": "Spain",
  "Holandia": "Netherlands",
  "Hongkong": "Hong Kong",
  "Hz):": "Hz):",
  "ID profilu stacji": "Station profile ID",
  "Identyfikator SWL": "SWL identifier",
  "Imie i Nazwisko": "First and last name",
  "Imię": "First name",
  "Imp. wej. → 50 Ω": "Input imp. → 50 Ω",
  "Import Cabrillo": "Cabrillo import",
  "Import certyfikatu nie powiodl sie: {0}": "Certificate import failed: {0}",
  "Import logu zawodów z pliku Cabrillo (np. eksport z N1MM+) -- pole wymiany może wymagać ręcznej poprawki dla bardziej złożonych formatów": "Import a contest log from a Cabrillo file (e.g. N1MM+ export) -- the exchange field may need manual correction for more complex formats",
  "Importuj potwierdzenia": "Import confirmations",
  "Importuj potwierdzenia LoTW": "Import LoTW confirmations",
  "Inne": "Other",
  "Integracje": "Integrations",
  "Italia": "Italy",
  "Izolator": "Insulator",
  "Izolator / maszt": "Insulator / mast",
  "Jak HamAlert, ale z wiedzą o Twoim logu: np. „nowy kraj na 20–10 m w CW” albo „każdy VP8* w nocy nie, w dzień tak”. Każdy spot alarmuje najwyżej raz na dobę na danym paśmie, maks. 12 alertów na godzinę na regułę.": "Like HamAlert, but aware of your log: e.g. “new country on 20–10 m in CW” or “every VP8* — not at night, yes during the day”. Each spot alerts at most once a day per band, max. 12 alerts per hour per rule.",
  "Jak Ty słyszałeś tę stację, np. 55 (głos) albo 559 (telegrafia). Czas UTC wpisze się sam.": "How you heard the station, e.g. 55 (voice) or 559 (telegraphy). The UTC time fills in by itself.",
  "Jak skonfigurować Discord": "How to set up Discord",
  "Jak skonfigurować Telegram": "How to set up Telegram",
  "Jako nasłuchowiec (SWL) zapisujesz stacje, które usłyszałeś w eterze. Pokażę Ci w minutę, gdzie co wpisać.": "As a listener (SWL) you log the stations you heard on the air. In a minute I’ll show you what goes where.",
  "Jan Kowalski": "John Smith",
  "Jasny": "Light",
  "Jestes już czlonkiem tego dziennika": "You are already a member of this logbook",
  "Jeszcze nie widziane": "Not seen yet",
  "Jeszcze niezaliczony": "Not worked yet",
  "Jeśli podany email istnieje w naszej bazie, wyslalismy link resetujacy hasło.": "If this e-mail exists in our database, we have sent a password reset link.",
  "Już w Twoim logu": "Already in your log",
  "Język": "Language",
  "Język opisów:": "Label language:",
  "Język zaproszenia": "Invitation language",
  "Kafelki pulpitu": "Dashboard tiles",
  "Kalendarz": "Calendar",
  "Kalka": "Tracing paper",
  "Karta QSL": "QSL card",
  "Karta QSL — druk / PDF": "QSL card — print / PDF",
  "Karta QSL — {0}": "QSL card — {0}",
  "Karta stacji": "Station card",
  "Karta stacji {0}": "Station card {0}",
  "Karty QSL (PDF)": "QSL cards (PDF)",
  "Karty QSL zaznaczonych QSO do druku (PDF, A4)": "QSL cards of the selected QSOs for printing (PDF, A4)",
  "Kategoria": "Category",
  "Kategoria mocy": "Power category",
  "Kategoria operatora": "Operator category",
  "Każdy może wpisać swój znak i sprawdzić, czy jego QSO z Tobą jest w logu (widzi tylko datę, pasmo i emisję swoich własnych QSO). Działa też dla Twoich znaków okolicznościowych.": "Anyone can enter their callsign and check whether their QSO with you is in your log (they only see the date, band and mode of their own QSOs). Also works for your special event callsigns.",
  "Kiedy": "When",
  "Kierunek": "Direction",
  "Kierunek u góry": "Direction up",
  "Kikuyu, Kenia": "Kikuyu, Kenya",
  "Kilka rzeczy, o których łatwo nie wiedzieć na start:": "A few things that are easy to miss at the start:",
  "Kilka słów od siebie (opcjonalnie)": "A few words from you (optional)",
  "Klasa": "Class",
  "Klaster": "Cluster",
  "Klaster DX (źródło spotów RBN) jeszcze się łączy albo chwilowo nie działa — dane RBN mogą być niepełne.": "The DX cluster (source of RBN spots) is still connecting or temporarily down — RBN data may be incomplete.",
  "Klaster niedostępny.": "Cluster unavailable.",
  "Kliknij kraj albo dowolny punkt na mapie, żeby zobaczyć azymut i odległość.": "Click a country or any point on the map to see the azimuth and distance.",
  "Kliknij swój identyfikator w prawym górnym rogu. Ustaw lokator swojej stacji (Konto → Lokalizacja stacji) — jest potrzebny do map i odległości.": "Click your identifier in the top right corner. Set your station locator (Account → Station location) — it is needed for maps and distances.",
  "Kliknij swój znak w prawym górnym rogu. Na początek ustaw lokator swojej stacji (Konto → Lokalizacja stacji) — jest potrzebny do map i liczenia odległości.": "Click your callsign in the top right corner. First set your station locator (Account → Station location) — it is needed for maps and distances.",
  "Kliknij „Dodaj do logu” (albo Ctrl+Enter) — gotowe. Pozostałe pola, np. imię, QTH czy notatki, są opcjonalne.": "Click “Add to log” (or Ctrl+Enter) — done. The other fields, e.g. name, QTH or notes, are optional.",
  "Kliknij, aby edytować": "Click to edit",
  "Kliknij, aby zobaczyc czego brakuje": "Click to see what is missing",
  "Kliknij, żeby pole podążało za radiem ({0} MHz / {1})": "Click to make the field follow the radio ({0} MHz / {1})",
  "Klucz API": "API key",
  "Klucz API TomTom (mapa POTA, opcjonalnie)": "TomTom API key (POTA map, optional)",
  "Klucz API z ustawień konta na hrdlog.net.": "The API key from your account settings on hrdlog.net.",
  "Klucz API, email i hasło z konta ClubLog.": "The API key, email and password of your ClubLog account.",
  "Klucz Logbook API (inny niż login do wyszukiwania znaków) znajdziesz na stronie swojego logbooka na QRZ.com, przycisk „API Key”. Wymaga subskrypcji QRZ „XML Logbook Data”.": "You will find the Logbook API key (different from the callsign lookup login) on your logbook page on QRZ.com, “API Key” button. Requires the QRZ “XML Logbook Data” subscription.",
  "Klucz głosowy i CW": "Voice and CW keyer",
  "Klucz jest zapamiętywany na koncie -- przy kolejnym eksporcie nie trzeba go wpisywać ponownie. Domyślnie ukryty (przydatne np. przy streamowaniu ekranu).": "The key is remembered on your account -- you don't need to enter it again for the next export. Hidden by default (useful e.g. when streaming your screen).",
  "Kod 2FA (z aplikacji lub zapasowy)": "2FA code (from the app or a backup code)",
  "Kod QR 2FA": "2FA QR code",
  "Kod wysyłki (Upload code), który HRDLOG przysyła e-mailem po rejestracji — to nie jest hasło do konta. Login to Twój znak.": "The upload code HRDLOG emails you after registration — it is not your account password. The login is your callsign.",
  "Kod wysyłki HRDLOG (Upload code)": "HRDLOG upload code",
  "Kod zaproszenia": "Invitation code",
  "Kolejka nowych stacji": "New station queue",
  "Kolejka pokazuje stacje wołające CQ w ostatnich 2 minutach, z którymi nie masz jeszcze QSO na danym paśmie. Każde QSO uruchamiasz sam — po jego zalogowaniu kolejka przechodzi do następnej stacji.": "The queue shows stations calling CQ in the last 2 minutes that you have no QSO with on that band yet. You start every QSO yourself — after it is logged, the queue moves on to the next station.",
  "Kolombo, Sri Lanka": "Colombo, Sri Lanka",
  "Kolumny": "Columns",
  "Komentarz": "Comment",
  "Komentarz do spotu (opcjonalnie, max 30 znaków, bez polskich liter):": "Spot comment (optional, max 30 characters, no Polish letters):",
  "Kompaktowa": "Compact",
  "Komunikaty — nadaj teraz": "Messages — send now",
  "Kondensator strojący": "Tuning capacitor",
  "Konfiguracja": "Configuration",
  "Konfiguracja WSJT-X": "WSJT-X configuration",
  "Konfiguracja radia": "Radio configuration",
  "Koniec": "End",
  "Koniec (": "End (",
  "Koniec wolny": "Free end",
  "Kontakt do administratora": "Contact the administrator",
  "Konto": "Account",
  "Konto HamQTH usunięte": "HamQTH account removed",
  "Konto zostało usunięte. 73!": "The account has been deleted. 73!",
  "Kopia wszystkich Twoich danych zapisanych na serwerze (profil, QSO, watchlista) w jednym pliku JSON.": "A copy of all your data stored on the server (profile, QSOs, watchlist) in a single JSON file.",
  "Kopiuj": "Copy",
  "Kosmos": "Space",
  "Kp={0} -- mozliwa nietypowa propagacja na 6m/2m (rozproszenie na zorzy polarnej). Im wyzej na polnoc/poludnie, tym wieksza szansa. Kliknij, zeby zamknac.": "Kp={0} -- unusual propagation possible on 6m/2m (auroral scatter). The further north/south, the better the chance. Click to close.",
  "Kraj": "Country",
  "Kraj (np. Reunion)": "Country (e.g. Reunion)",
  "Kraj DXCC": "DXCC country",
  "Kraj DXCC / prefiks": "DXCC country / prefix",
  "Kraje": "Countries",
  "Kraje (DXCC)": "Countries (DXCC)",
  "Kraje / DXCC": "Countries / DXCC",
  "Kraje DXCC": "DXCC entities",
  "Kraje:": "Countries:",
  "Krok {0} z {1}": "Step {0} of {1}",
  "Krótka droga:": "Short path:",
  "Krótki przewodnik: gdzie wpisać łączność w loggerze, gdzie jest dziennik i ustawienia.": "A short guide: where to enter a QSO in the logger, where the logbook and settings are.",
  "Krótkofalowiec": "Radio amateur",
  "Kto mnie słyszy": "Who hears me",
  "Które stacje": "Which stations",
  "Kupię": "Wanted",
  "Kwi": "Apr",
  "Las": "Forest",
  "Liczba znaków (": "Number of characters (",
  "Liczba łączności": "Number of QSOs",
  "Liczenie...": "Counting...",
  "Liczone z logów uczestników: QSO i CW w wybranym miesiącu, parki POTA (pole POTA w QSO) w miesiącu, kraje DXCC w całym roku.": "Counted from participants' logs: QSOs and CW in the selected month, POTA parks (POTA field in the QSO) in the month, DXCC countries over the whole year.",
  "Liczy się kraj zrobiony na": "Counts a country worked on",
  "Liczy się liczba różnych pól lokatora Maidenhead (4 znaki) na pasmach 6m/2m/70cm -- wymaga wypełnionego pola \"Lokator\" w QSO. Podstawowy próg dyplomu ARRL to 100 pól.": "Counts distinct Maidenhead grid squares (4 characters) on 6m/2m/70cm -- requires the \"Locator\" field filled in the QSO. The basic ARRL award threshold is 100 squares.",
  "Link zaproszenia": "Invitation link",
  "Lip": "Jul",
  "Lis": "Nov",
  "Lista": "List",
  "Lista aktywacji będzie dostępna online.": "The list of activations will be available online.",
  "Litwa": "Lithuania",
  "LoTW odpowiedzialo bledem: {0}": "LoTW returned an error: {0}",
  "LoTW wymaga podpisania logu certyfikatem stacji (plik .tq6 z Twojego konta LoTW, zakladka \"Your Callsign Certificates\" na lotw.arrl.org). Wgraj go raz ponizej -- hasło i tresc certyfikatu są szyfrowane na serwerze, a certyfikat trzymany jest w izolowanym magazynie osobnym dla kazdego konta.": "LoTW requires signing the log with a station certificate (.tq6 file from your LoTW account, \"Your Callsign Certificates\" tab on lotw.arrl.org). Upload it once below -- the password and certificate content are encrypted on the server, and the certificate is kept in an isolated store separate for each account.",
  "Log QSO (Alt+Q) — otwiera okno logowania w WSJT-X": "Log QSO (Alt+Q) — opens the WSJT-X log window",
  "Log tej stacji nie jest publicznie dostępny do przeszukiwania.": "This station's log is not publicly searchable.",
  "Login (opcjonalnie)": "Login (optional)",
  "Login HamQTH": "HamQTH login",
  "Login do lotw.arrl.org": "lotw.arrl.org login",
  "Login i hasło do eQSL.cc. QTH Nickname podaj, jeśli masz w eQSL kilka lokalizacji.": "Your eQSL.cc login and password. Enter the QTH Nickname if you have several locations in eQSL.",
  "Logowanie": "Log in",
  "Logowanie QRZ.com": "QRZ.com login",
  "Logowałeś się na wspólnym komputerze (np. w klubie) albo podejrzewasz, że ktoś ma dostęp do konta? Wyloguj wszystkie inne sesje — ta zostanie aktywna.": "Logged in on a shared computer (e.g. at a club) or suspect someone has access to your account? Log out all other sessions — this one stays active.",
  "Lohja, Finlandia": "Lohja, Finland",
  "Lokalizacja": "Location",
  "Lokalizacja niedostępna (sprawdź czy usługi lokalizacji są włączone w systemie/przeglądarce)": "Location unavailable (check that location services are enabled in the system/browser)",
  "Lokalizacja stacji": "Station location",
  "Lokalizacja zapisana: {0}": "Location saved: {0}",
  "Lokator": "Locator",
  "Lokator (Maidenhead) Twojego QTH — używany na mapach, do liczenia odległości i azymutów oraz w wyszukiwarce sąsiadów.": "The Maidenhead locator of your QTH — used on maps, for distances and azimuths, and in the neighbour search.",
  "Lokator DX": "DX locator",
  "Lokator stacji (np. praca portable)": "Station locator (e.g. portable operation)",
  "Lokator z GPS: {0} (dokładność ok. {1} m)": "Locator from GPS: {0} (accuracy about {1} m)",
  "Lokator:": "Locator:",
  "Losowe": "Random",
  "Lut": "Feb",
  "MHz, np. 14.074": "MHz, e.g. 14.074",
  "Madera, Portugalia": "Madeira, Portugal",
  "Maj": "May",
  "Maks. km": "Max. km",
  "Maks. moc (W)": "Max. power (W)",
  "Maksymalnie 60 kart naraz": "At most 60 cards at once",
  "Mam znak wywoławczy i nadaję": "I have a callsign and transmit",
  "Mapa": "Map",
  "Mapa TomTom: administrator wpisuje klucz API w Panel admina → Ustawienia.": "TomTom map: the administrator enters the API key in Admin panel → Settings.",
  "Mapa azymutalna": "Azimuthal map",
  "Mapa pasma": "Band map",
  "Mar": "Mar",
  "Masterton, N. Zelandia": "Masterton, New Zealand",
  "Masz:": "You have:",
  "Maui, Hawaje": "Maui, Hawaii",
  "Mały program działający na komputerze podłączonym do radia (nie na serwerze) -- automatycznie wysyła do Twojego dziennika każde QSO zalogowane w WSJT-X, oraz (jeśli masz skonfigurowane radio w zakładce \"📻 Radio\") odczytuje częstotliwość i wykonuje QSY. Jeden program robi teraz obie rzeczy naraz. Nie musisz niczego ręcznie wpisywać -- oba pliki poniżej są już gotowe.": "A small program running on the computer connected to the radio (not on the server) -- it automatically sends every QSO logged in WSJT-X to your logbook and (if you have configured a radio in the \"📻 Radio\" tab) reads the frequency and performs QSY. One program now does both. You don't have to type anything manually -- both files below are ready.",
  "Menu główne": "Main menu",
  "Metoda Kocha": "Koch method",
  "Mgla": "Fog",
  "Mgla osadzajaca szadz": "Depositing rime fog",
  "Miejscowość": "Town",
  "Miesiące": "Months",
  "Miesięczne podsumowanie logu mailem": "Monthly log summary by e-mail",
  "Mini zawody: kto zaprosi najwięcej": "Mini contest: who invites the most",
  "Moc": "Power",
  "Moc (W)": "Power (W)",
  "Moc {0} W przekracza Twój limit {1} W.": "Power {0} W exceeds your limit of {1} W.",
  "Model obrotnicy": "Rotator model",
  "Moje": "Mine",
  "Moje QTH": "My QTH",
  "Moje dane (RODO)": "My data (GDPR)",
  "Moje uprawnienia": "My license privileges",
  "Monitor wł./wył. (Alt+M)": "Monitor on/off (Alt+M)",
  "Motyw": "Theme",
  "Motyw eksperymentalny (animowany)": "Experimental (animated) theme",
  "Motywy": "Themes",
  "Motywy dla {0}": "Themes for {0}",
  "Możesz zaczynać. Samouczek otworzysz ponownie w Ustawienia konta → Wygląd i preferencje → „Pokaż samouczek”.": "You can start now. Open this tutorial again in Account settings → Appearance and preferences → “Show tutorial”.",
  "Mt. Asama, Japonia": "Mt. Asama, Japan",
  "Mzawka": "Drizzle",
  "Mzawka intensywna": "Dense drizzle",
  "Mzawka marznaca": "Freezing drizzle",
  "Mzawka marznaca intensywna": "Dense freezing drizzle",
  "Mzawka slaba": "Light drizzle",
  "Mój lokator": "My locator",
  "Mój park POTA": "My POTA park",
  "Mój sprzęt": "My equipment",
  "NADAJE": "TRANSMITTING",
  "Na tej częstotliwości:": "On this frequency:",
  "Na telefonie dziennik jest na dolnym pasku.": "On a phone the logbook is on the bottom bar.",
  "Na żywo z radia:": "Live from the radio:",
  "Nadaj": "Send",
  "Nadaj teraz (następny okres TX)": "Send now (next TX period)",
  "Nadaje teraz": "Transmitting now",
  "Nadany": "Sent",
  "Nadawanie": "Transmit",
  "Nadawanie z HamLoggera jest wyłączone. Włączysz je w pliku hamlogger_agent.ini:": "Transmitting from HamLogger is off. Turn it on in hamlogger_agent.ini:",
  "Nadawanie z HamLoggera wyłączone w agencie (allow_tx_control = false)": "Transmitting from HamLogger is turned off in the agent (allow_tx_control = false)",
  "Nadawanie z loggera jest wyłączone — włącz zgodę w panelu „Radio przez USB”": "Transmitting from the logger is off — enable it in the “Radio over USB” panel",
  "Nadchodzące": "Upcoming",
  "Najbliżej zdobycia": "Closest to completion",
  "Najbliższe zawody": "Upcoming contests",
  "Najczęstsi korespondenci": "Most frequent contacts",
  "Najczęściej mylone": "Most often wrong",
  "Najdłuższe QSO:": "Longest QSO:",
  "Najnowsze wiadomości ze świata krótkofalarstwa, zebrane z kilku źródeł w jednym miejscu. Kliknij tytuł, aby przeczytać pełny artykuł na stronie źródłowej.": "The latest amateur radio news, gathered from several sources in one place. Click a title to read the full article on the source website.",
  "Najprostszy test propagacji: posłuchaj, czy słychać radiolatarnię z danego kierunku. Każda nadaje znak i 4 kreski o mocy 100 W → 10 W → 1 W → 0,1 W — im więcej kresek słyszysz, tym lepsze warunki. Emisja CW, klik = przestrojenie radia.": "The simplest propagation test: listen whether you can hear a beacon from a given direction. Each one sends its callsign and 4 dashes at 100 W → 10 W → 1 W → 0.1 W — the more dashes you hear, the better the conditions. CW mode, click = retune the radio.",
  "Najszybszy sposób, żeby znaleźć dowolną funkcję, znak albo QSO. Skrót klawiszowy: Ctrl+K.": "The quickest way to find any feature, callsign or QSO. Keyboard shortcut: Ctrl+K.",
  "Najwięcej QSO CW w miesiącu": "Most CW QSOs in the month",
  "Najwięcej QSO w miesiącu": "Most QSOs in the month",
  "Najwięcej krajów DXCC w roku": "Most DXCC countries in the year",
  "Najwięcej parków POTA w miesiącu": "Most POTA parks in the month",
  "Największa korzyść: port szeregowy może otworzyć tylko": "The biggest benefit: a serial port can be opened by only",
  "Najwyższa ranga — gratulacje!": "Top rank — congratulations!",
  "Namiar i odległość od Twojej lokalizacji do {0}": "Bearing and distance from your location to {0}",
  "Napisz wiadomość… (@ZNAK powiadomi tę osobę)": "Write a message… (@CALLSIGN notifies that person)",
  "Naprowadzanie anteny na satelity": "Pointing the antenna at satellites",
  "Narodowe (wg Twojego znaku)": "National (by your callsign)",
  "Nast. →": "Next →",
  "Nastaw radio": "Tune radio",
  "Nastaw radio na ta czestotliwosc (wymaga agenta CAT)": "Tune the radio to this frequency (requires the CAT agent)",
  "Nastaw radio na tę częstotliwość (wymaga agenta CAT)": "Tune the radio to this frequency (requires the CAT agent)",
  "Następna": "Next",
  "Nasłuch UDP": "UDP listener",
  "Nasłuchowiec (SWL)": "Listener (SWL)",
  "Nasłuchy": "SWL",
  "Nasłuchy (SWL)": "Listening log (SWL)",
  "Nauka": "Study",
  "Nazwa": "Name",
  "Nazwa konfiguracji": "Configuration name",
  "Nazwa profilu": "Profile name",
  "Nazwa sieci": "Net name",
  "Nazwa użytkownika eQSL": "eQSL username",
  "Nazwa zawodow": "Contest name",
  "Ndz": "Sun",
  "Nic jeszcze nie przyszło": "Nothing has arrived yet",
  "Nic nie pasuje do filtrów.": "Nothing matches the filters.",
  "Nic nie pasuje do „": "Nothing matches “",
  "Nic nie znaleziono.": "Nothing found.",
  "Nie": "No",
  "Nie dodano do watchlisty": "Not added to the watchlist",
  "Nie masz jeszcze aktywacji z zapisanym parkiem.": "You have no activations with a saved park yet.",
  "Nie masz jeszcze profili.": "You have no profiles yet.",
  "Nie masz jeszcze reguł. Zacznij od „Nowa reguła” — domyślnie alarmuje o nowych krajach.": "You have no rules yet. Start with “New rule” — by default it alerts about new countries.",
  "Nie mozna polaczyc z QRZ.com": "Cannot connect to QRZ.com",
  "Nie można użyć wybranego wyjścia audio": "Cannot use the selected audio output",
  "Nie prowadzisz jeszcze żadnej sieci. Kliknij \"➕ Nowa sieć\", żeby zacząć.": "You are not running any net yet. Click \"➕ New net\" to start.",
  "Nie przyszły żadne dodatkowe dekody.": "No additional decodes arrived.",
  "Nie rozpoznano znaku -- spróbuj jeszcze raz (alfabet fonetyczny, po angielsku)": "Callsign not recognised -- try again (phonetic alphabet, in English)",
  "Nie sprawdzono. Kliknij „Test sterowania” — WSJT-X powinien odesłać dekody z okna Band Activity.": "Not checked. Click “Control test” — WSJT-X should resend the decodes from the Band Activity window.",
  "Nie udalo sie pobrac spotow WWFF": "Could not fetch WWFF spots",
  "Nie udalo sie pobrac wiadomosci": "Could not fetch the news",
  "Nie udało się otworzyć portu: {0}": "Could not open the port: {0}",
  "Nie udało się pobrać danych karty": "Could not fetch card data",
  "Nie udało się pobrać etykiet": "Could not fetch labels",
  "Nie udało się pobrać karty.": "Could not download the card.",
  "Nie udało się pobrać kolejki QSL": "Could not fetch the QSL queue",
  "Nie udało się pobrać listy Most Wanted": "Could not fetch the Most Wanted list",
  "Nie udało się pobrać listy satelitow": "Could not fetch the satellite list",
  "Nie udało się pobrać pliku ADIF.": "Could not download the ADIF file.",
  "Nie udało się pobrać potwierdzeń z LoTW.": "Could not download confirmations from LoTW.",
  "Nie udało się rozłączyć QRZ.com": "Could not disconnect QRZ.com",
  "Nie udało się skopiować": "Could not copy",
  "Nie udało się uruchomic mikrofonu -- sprawdź uprawnienia przeglądarki": "Could not start the microphone -- check the browser permissions",
  "Nie udało się ustalić położenia.": "Could not determine your position.",
  "Nie udało się usunąć konta": "Could not delete the account",
  "Nie udało się wczytać celów.": "Could not load goals.",
  "Nie udało się wczytać listy zmian.": "Could not load the changelog.",
  "Nie udało się wczytać zaproszeń.": "Could not load invitations.",
  "Nie udało się wygenerować kart QSL.": "Could not generate QSL cards.",
  "Nie udało się wygenerować karty QSL.": "Could not generate the QSL card.",
  "Nie udało się wygenerować obrazka": "Could not generate the image",
  "Nie udało się wysłać polecenia do WSJT-X": "Could not send the command to WSJT-X",
  "Nie udało się wysłać zaproszenia.": "Could not send the invitation.",
  "Nie udało się włączyć powiadomień push": "Could not enable push notifications",
  "Nie udało się zapisać nagrania": "Could not save the recording",
  "Nie wygaszaj": "Keep screen on",
  "Nie wygaszaj ekranu podczas aktywacji": "Keep the screen on during the activation",
  "Nie wykryto radia — sprawdź kabel i czy port nie jest zajęty, albo wybierz model ręcznie": "No radio detected — check the cable and that the port is not in use, or pick the model manually",
  "Nie wysłane do QRZ Logbook": "Not sent to QRZ Logbook",
  "Nie wysłano": "Not sent",
  "Nie zapisano ustawień podświetlania": "Highlight settings not saved",
  "Nie znaleziono parku o tej referencji": "No park found with this reference",
  "Niebo (sky plot)": "Sky plot",
  "Niemcy": "Germany",
  "Nieprawidlowy format lokatora (np. KO02, JO91ab)": "Invalid locator format (e.g. KO02, JO91ab)",
  "Nieprawidłowe wspolrzedne": "Invalid coordinates",
  "Nieprawidłowy adres CI-V (hex, np. 94)": "Invalid CI-V address (hex, e.g. 94)",
  "Nieprawidłowy kod": "Invalid code",
  "Nieprawidłowy kod zaproszenia": "Invalid invitation code",
  "Nieprawidłowy lokator (np. KO02 lub JO82FX)": "Invalid locator (e.g. KO02 or JO82FX)",
  "Niewysłane (": "Not sent (",
  "Nikt Cię nie słyszał w ostatniej godzinie (albo nie nadawałeś). PSK Reporter: nadaj FT8/FT4 z WSJT-X. RBN: zawołaj CQ na CW, np. „CQ CQ DE {0} {0} K”.": "Nobody heard you in the last hour (or you were not transmitting). PSK Reporter: transmit FT8/FT4 from WSJT-X. RBN: call CQ on CW, e.g. “CQ CQ DE {0} {0} K”.",
  "Nikt jeszcze nie ma wyniku.": "Nobody has a score yet.",
  "Nikt jeszcze nie zdobył punktów.": "Nobody has scored points yet.",
  "Notatka": "Note",
  "Notatki": "Notes",
  "Nowa emisja dla kraju": "New mode for the country",
  "Nowa grupa": "New group",
  "Nowa reguła": "New rule",
  "Nowa sieć": "New net",
  "Nowe QSO": "New QSO",
  "Nowe hasła nie są identyczne": "New passwords do not match",
  "Nowe hasło": "New password",
  "Nowe hasło musi miec min. 6 znaków": "The new password must be at least 6 characters",
  "Nowe kraje": "New countries",
  "Nowe ogłoszenie": "New listing",
  "Nowe pasmo dla kraju": "New band for the country",
  "Nowe pasmo/mode z tą stacją": "New band/mode with this station",
  "Nowe potwierdzenia z LoTW sprawdzane są co 6 godzin (login do lotw.arrl.org podajesz w zakładce Serwisy QSO). Odznaki za cele przychodzą zawsze — zobaczysz je w dzwonku.": "New LoTW confirmations are checked every 6 hours (enter your lotw.arrl.org login in the QSO services tab). Goal badges always arrive — you will see them in the bell.",
  "Nowe potwierdzenia z LoTW: {0}{1}": "New LoTW confirmations: {0}{1}",
  "Nowosybirsk, Rosja": "Novosibirsk, Russia",
  "Nowy dziennik (np. stacja klubowa)": "New logbook (e.g. club station)",
  "Nowy kraj": "New country",
  "Nowy kraj (DXCC)!": "New country (DXCC)!",
  "Nowy na": "New on",
  "Nowy park dla Ciebie": "New park for you",
  "Nowy profil": "New profile",
  "Nowy token unieważni stary -- już uruchomiony agent przestanie działać, dopóki nie pobierzesz nowej konfiguracji. Kontynuować?": "A new token invalidates the old one -- an already running agent will stop working until you download the new configuration. Continue?",
  "Nowy token wygenerowany -- pobierz konfigurację ponownie (przycisk wyżej)": "New token generated -- download the configuration again (button above)",
  "Numer nasłuchowca (np. SP9-1234) albo inny identyfikator — litery, cyfry, „/” i „-”. Będziesz się nim logować. Konto zaczyna od dziennika nasłuchów; zwykłe QSO możesz dodać później, gdy zdobędziesz licencję.": "Listener number (e.g. SP9-1234) or another identifier — letters, digits, “/” and “-”. You will log in with it. The account starts with the listening log; you can add regular QSOs later, once you get a license.",
  "ONZ, Nowy Jork": "UN, New York",
  "OSTATECZNE POTWIERDZENIE: usunąć konto i WSZYSTKIE dane (QSO, ustawienia, klucze)? Tego nie da się cofnąć.": "FINAL CONFIRMATION: delete the account and ALL data (QSOs, settings, keys)? This cannot be undone.",
  "Obecność": "Attendance",
  "Obrotnica ma też elewację (typowe dla śledzenia satelitów)": "The rotator also has elevation (typical for satellite tracking)",
  "Obrotnica nie jest podłączona": "Rotator is not connected",
  "Obrotnica nie odpowiada — sprawdź protokół i prędkość": "Rotator not responding — check the protocol and baud rate",
  "Obrotnica przez USB (bez agenta)": "Rotator over USB (no agent)",
  "Obrót działa z agentem HamLoggera i skonfigurowanym rotorem.": "Rotation works with the HamLogger agent and a configured rotator.",
  "Obrót mapy:": "Map rotation:",
  "Obróć": "Rotate",
  "Obróć (LP)": "Rotate (LP)",
  "Obróć (SP)": "Rotate (SP)",
  "Obróć mapę tak, by ten kierunek był u góry": "Rotate the map so this direction is at the top",
  "Obróć o 15° w lewo": "Rotate 15° left",
  "Obróć o 15° w prawo": "Rotate 15° right",
  "Obszar": "Area",
  "Ocean": "Ocean",
  "Ocena, jak dobrze się słyszycie. Przy łączności głosowej zwykle 59, w telegrafii 599. „Nadany” to raport, który Ty dałeś korespondentowi, „odebrany” — który od niego dostałeś.": "How well you hear each other. Usually 59 for voice and 599 for telegraphy. “Sent” is the report you gave, “received” is the one you got.",
  "Oceń, które pasmo może być otwarte na tej trasie": "Estimate which band may be open on this path",
  "Od początku": "All time",
  "Odbiór i ustawienia": "Receive and settings",
  "Odblokuj motywy dla tej stacji": "Unlock themes for this station",
  "Oddal": "Zoom out",
  "Oddam": "Free",
  "Odebrane z WSJT-X": "Received from WSJT-X",
  "Odebrany": "Received",
  "Odepnij": "Unpin",
  "Odległość": "Distance",
  "Odległość:": "Distance:",
  "Odmówiono dostępu do lokalizacji": "Location access denied",
  "Odpowiadanie stacjom i nadawanie tekstu z HamLoggera jest wyłączone. Włączysz je w pliku hamlogger_agent.ini:": "Replying to stations and sending text from HamLogger is turned off. Turn it on in hamlogger_agent.ini:",
  "Odpowiadanie z HamLoggera jest wyłączone w agencie (allow_tx_control = false)": "Replying from HamLogger is turned off in the agent (allow_tx_control = false)",
  "Odpowiadanie z HamLoggera jest wyłączone. Włączysz je w pliku hamlogger_agent.ini:": "Replying from HamLogger is turned off. Turn it on in hamlogger_agent.ini:",
  "Odpowiadanie z HamLoggera wyłączone": "Replying from HamLogger is off",
  "Odpowiadanie z HamLoggera włączone": "Replying from HamLogger is on",
  "Odpowiedz": "Reply",
  "Odpowiedz na CQ": "Reply to CQ",
  "Odpowiedz następnej:": "Reply to next:",
  "Odpowiedz tej stacji na jej CQ (jak dwuklik w WSJT-X)": "Reply to this station’s CQ (like a double-click in WSJT-X)",
  "Odpowiedz {0} w WSJT-X (uruchamia nadawanie)": "Reply to {0} in WSJT-X (starts transmitting)",
  "Odpowiedz…": "Reply…",
  "Odtwórz nagranie": "Play recording",
  "Odwolac token API? Wszystkie skrypty go uzywajace przestana działać.": "Revoke the API token? All scripts using it will stop working.",
  "Odznacz wszystkie": "Clear all",
  "Odznaki (": "Badges (",
  "Odśwież spoty": "Refresh spots",
  "Odśwież stronę": "Refresh the page",
  "Ogólny (RST + numer)": "General (RST + serial)",
  "Ogłoszenia": "Listings",
  "Ogłoszenie zapisane": "Listing saved",
  "Okienko w aplikacji, a gdy HamLogger jest zamknięty — powiadomienie push (jeśli włączysz je w przeglądarce w regułach alertów). Każde ostrzeżenie przychodzi raz.": "A pop-up in the app and, when HamLogger is closed, a push notification (if you enable them in the browser under alert rules). Each warning arrives once.",
  "Okres": "Period",
  "Opis": "Description",
  "Opis (np. Przemiennik SR3PO)": "Description (e.g. Repeater SR3PO)",
  "Opis (opcjonalnie)": "Description (optional)",
  "Opis na QRZ": "Description on QRZ",
  "Opuscic / usunac ten dziennik?": "Leave / delete this logbook?",
  "Ostatni pakiet {0}.": "Last packet {0}.",
  "Ostatni: {0}": "Last: {0}",
  "Ostatnia automatyczna próba:": "Last automatic attempt:",
  "Ostatnia godzina. PSK Reporter — emisje cyfrowe (FT8/FT4/JS8…) z lokatorem odbiornika; Reverse Beacon Network — CW i RTTY ze skimmerów (położenie: środek kraju).": "Last hour. PSK Reporter — digital modes (FT8/FT4/JS8…) with the receiver's locator; Reverse Beacon Network — CW and RTTY from skimmers (position: centre of the country).",
  "Ostatnia udana wysyłka:": "Last successful upload:",
  "Ostatnia wysyłka:": "Last upload:",
  "Ostatnie QSO": "Recent QSOs",
  "Ostatnie dane: {0}.": "Last data: {0}.",
  "Ostatnio": "Recently",
  "Ostatnio: {0} UTC · automatycznie co 6 h": "Last: {0} UTC · automatically every 6 h",
  "Ostrzegaj od porywów": "Warn from gusts of",
  "Ostrzeżenia": "Warnings",
  "Otrzymana": "Received",
  "Otworz": "Open",
  "Otwórz": "Open",
  "Otwórz pota.app": "Open pota.app",
  "Otwórz reguły alertów": "Open alert rules",
  "Otwórz wysyłkę do serwisów": "Open upload to services",
  "Oznacz jako przeczytane": "Mark as read",
  "Oznacz jako wysłane": "Mark as sent",
  "Oznacz jako zrobiony": "Mark as done",
  "Oznaczono {0} QSO jako wyslane": "Marked {0} QSOs as sent",
  "Oznaczyc wszystkie niewyslane QSO jako wysłane do LoTW? Rob to DOPIERO po faktycznym wgraniu pliku przez TQSL.": "Mark all unsent QSOs as sent to LoTW? Do this ONLY after actually uploading the file with TQSL.",
  "PIONOWA ĆWIERĆFALOWA (GROUND PLANE) — schemat techniczny (widok boczny)": "QUARTER-WAVE VERTICAL (GROUND PLANE) — technical drawing (side view)",
  "PTT (kliknij, żeby nadawać)": "PTT (click to transmit)",
  "Pakiety spoza protokołu WSJT-X": "Packets outside the WSJT-X protocol",
  "Park korespondenta (park-to-park), opcjonalnie": "Their park (park-to-park), optional",
  "Pasek u góry": "Bar at the top",
  "Pasma": "Bands",
  "Pasma (nic = wszystkie)": "Bands (none = all)",
  "Pasma i emisje": "Bands and modes",
  "Pasma:": "Bands:",
  "Pasmo": "Band",
  "Pasmo ({0})": "Band ({0})",
  "Pasmo ({0}) [m]": "Band ({0}) [m]",
  "Pasmo {0} nie jest na liście Twoich uprawnień (Ustawienia → Profil).": "Band {0} is not on your list of license privileges (Settings → Account).",
  "Pasmo:": "Band:",
  "Pauza": "Pause",
  "Paź": "Oct",
  "Pełna karta": "Full card",
  "Pełny opis na QRZ": "Full description on QRZ",
  "Pełny pilot WSJT-X": "Full WSJT-X remote",
  "Pierwsze QSO z tą stacją": "First QSO with this station",
  "Pierwsze QSO z tą stacją.": "First QSO with this station.",
  "Plik MASTER.SCP (lista znaków aktywnych w zawodach, znak na linię) — w trybie zawodów loggera podpowiada pasujące znaki po wpisaniu fragmentu. Aktualny plik jest do pobrania ze strony supercheckpartial.com.": "MASTER.SCP file (callsigns active in contests, one per line) — in the logger's contest mode it suggests matching callsigns as you type a fragment. Download the current file from supercheckpartial.com.",
  "Po teście WSJT-X odesłał {0} dekodów — opcja „Accept UDP requests” jest włączona.": "After the test WSJT-X resent {0} decodes — “Accept UDP requests” is enabled.",
  "Po włączeniu logger będzie mógł uruchamiać nadajnik: przycisk PTT i makra CW (F7–F12) wysyłane do radia. Nadajesz zawsze Ty — klikając. Włączyć?": "When enabled, the logger can key the transmitter: the PTT button and CW macros (F7–F12) sent to the radio. It is always you who transmits — by clicking. Enable?",
  "Po zapisaniu QSO wyśle automatycznie graficzną kartę eQSL mailem na adres znaleziony w QRZ (jeśli druga stacja go udostępniła publicznie)": "After saving the QSO it automatically e-mails a graphical eQSL card to the address found on QRZ (if the other station made it public)",
  "Pobieram…": "Downloading…",
  "Pobieranie potwierdzeń (opcjonalnie)": "Downloading confirmations (optional)",
  "Pobierz konfigurację (auto-uzupełnioną)": "Download configuration (pre-filled)",
  "Pobierz moje dane": "Download my data",
  "Pobierz obrazek": "Download image",
  "Pobierz plik": "Download file",
  "Pobierz plik ADIF aktywacji poniżej (nazwa zgodna z wymaganiami POTA).": "Download the activation ADIF file below (named as POTA requires).",
  "Pobierz potwierdzenia": "Download confirmations",
  "Pobierz program (.exe)": "Download program (.exe)",
  "Pobierz z bip.uke.gov.pl": "Download from bip.uke.gov.pl",
  "Pobrano dane konta": "Account data downloaded",
  "Pobrany plik konfiguracji zawiera Twój prywatny token dostępu do agenta -- traktuj go jak hasło, nie udostępniaj nikomu.": "The downloaded configuration file contains your private agent access token -- treat it like a password, do not share it with anyone.",
  "Pochmurno": "Overcast",
  "Początek (UTC)": "Start (UTC)",
  "Początek QSO zapisany przy wpisaniu znaku; koniec zapisze się przy zapisie": "QSO start was recorded when the callsign was typed; the end is recorded on save",
  "Pod horyzontem. Najbliższy przelot: max elewacja": "Below the horizon. Next pass: max elevation",
  "Podaj częstotliwość w MHz.": "Enter the frequency in MHz.",
  "Podaj poprawną częstotliwość (MHz)": "Enter a valid frequency (MHz)",
  "Podgląd karty QSL": "QSL card preview",
  "Podpowiedź chwilowo niedostępna.": "The suggestion is temporarily unavailable.",
  "Podsumowanie roku": "Year summary",
  "Podświetlaj w WSJT-X:": "Highlight in WSJT-X:",
  "Pokaż klucz": "Show key",
  "Pokaż parki": "Show parks",
  "Pokaż samouczek": "Show tutorial",
  "Pokaż starsze wersje (": "Show older versions (",
  "Pokaż tylko najważniejsze: logger, dziennik, statystyki i wysyłkę QSO. Zmienisz to w ustawieniach konta.": "Show only the essentials: logger, logbook, statistics and QSO upload. You can change this in account settings.",
  "Pokaż zakonczone": "Show finished",
  "Poland": "Poland",
  "Polska": "Poland",
  "Pomiary": "Test equipment",
  "Pomiń": "Skip",
  "Pomiń tę stację": "Skip this station",
  "Pomniejsz": "Zoom out",
  "Pomniejsz rysunek": "Shrink the figure",
  "Pon": "Mon",
  "Poproś WSJT-X o ponowne wysłanie dekodów (sprawdza „Accept UDP requests”)": "Ask WSJT-X to resend decodes (checks “Accept UDP requests”)",
  "Port": "Port",
  "Port szeregowy": "Serial port",
  "Port szeregowy (agent sam uruchomi rigctld)": "Serial port (the agent starts rigctld itself)",
  "Port szeregowy (agent sam uruchomi rotctld)": "Serial port (the agent starts rotctld itself)",
  "Portable / POTA": "Portable / POTA",
  "Postep:": "Progress:",
  "Postęp DXCC": "DXCC progress",
  "Postęp do następnej rangi": "Progress to the next rank",
  "Postęp liczony z Twojego logu. Za każdy osiągnięty cel dostajesz odznakę i powiadomienie.": "Progress is calculated from your log. Every goal you reach earns a badge and a notification.",
  "Postęp w dyplomach": "Award progress",
  "Posłuchaj i zapisz, co usłyszałeś. Potem kliknij „Pokaż odpowiedź\".": "Listen and write down what you heard. Then click “Show answer\".",
  "Potw.": "Conf.",
  "Potwierdzenia i odznaki": "Confirmations and badges",
  "Potwierdzenie": "Confirmation",
  "Potwierdzenie łączności z:": "Confirming QSO with:",
  "Powiadamiaj o nowych aktywatorach akcji dyplomowych": "Notify about new award activators",
  "Powiadom o nowych potwierdzeniach QSL (np. „5 nowych z LoTW, w tym nowy kraj”)": "Notify about new QSL confirmations (e.g. “5 new from LoTW, including a new country”)",
  "Powiadomienia": "Notifications",
  "Powiadomienia ({0} nieprzeczytanych)": "Notifications ({0} unread)",
  "Powiadomienia push (ta przeglądarka)": "Push notifications (this browser)",
  "Powiadomienia push wyłączone dla tej przeglądarki": "Push notifications turned off for this browser",
  "Powiadomienia push włączone dla tej przeglądarki 🔔": "Push notifications turned on for this browser 🔔",
  "Powiadomienia w przeglądarce i reguły alertów": "Browser notifications and alert rules",
  "Powiadomienie push": "Push notification",
  "Powiększ": "Zoom in",
  "Powiększ rysunek": "Enlarge the figure",
  "Powiększanie: kółko myszy albo przyciski +/−. Przesuwanie: przeciągnij powiększoną mapę.": "Zoom: mouse wheel or +/− buttons. Pan: drag the zoomed-in map.",
  "Powtórz": "Repeat",
  "Powtórz nowe hasło": "Repeat new password",
  "Pozwala pisać własne skrypty i integracje, które czytają Twój log (np. statystyki na stronie klubu). Daje dostęp tylko do odczytu Twojego logu — traktuj go jak hasło.": "Lets you write your own scripts and integrations that read your log (e.g. statistics on a club website). Gives read-only access to your log — treat it like a password.",
  "Pozwól loggerowi nadawać (PTT, makra CW)": "Allow the logger to transmit (PTT, CW macros)",
  "Połącz QRZ.com (wyszukiwanie znaków)": "Connect QRZ.com (callsign lookup)",
  "Połącz obrotnicę": "Connect rotator",
  "Połącz ponownie": "Reconnect",
  "Połącz radio": "Connect radio",
  "Połącz z QRZ.com": "Connect to QRZ.com",
  "Pracowane kraje (": "Worked countries (",
  "Pracowane kraje (DXCC)": "Worked countries (DXCC)",
  "Pracowane kraje:": "Worked countries:",
  "Pracowany": "Worked",
  "Pracowała z": "Worked with",
  "Prawie bezchmurnie": "Mainly clear",
  "Prefiksy": "Prefixes",
  "Prefiksy:": "Prefixes:",
  "Pretoria, RPA": "Pretoria, South Africa",
  "Profil": "Profile",
  "Profil publiczny": "Public profile",
  "Profil publiczny włączony": "Public profile enabled",
  "Profil publiczny, webhooki i inne ustawienia konta -- kliknij swoj znak (": "Public profile, webhooks and other account settings -- click your callsign (",
  "Profil sugeruje Silent Key — sprawdź przed logowaniem.": "The profile suggests a Silent Key — check before logging.",
  "Profil to zestaw radio + antena (+ typowa moc). Wybierasz go w loggerze nad polem znaku — sprzęt zapisuje się przy każdym QSO (także w eksporcie ADIF jako MY_RIG / MY_ANTENNA).": "A profile is a radio + antenna set (+ typical power). You choose it in the logger above the callsign field — the equipment is saved with every QSO (also in the ADIF export as MY_RIG / MY_ANTENNA).",
  "Promien wyszukiwania:": "Search radius:",
  "Promiennik (λ/2)": "Radiator (λ/2)",
  "Propagacja": "Propagation",
  "Propagacja trasy": "Path propagation",
  "Prosi o powtórzenie raportu": "Asks for the report to be repeated",
  "Prowadzenie sieci": "Net control",
  "Prywatność i profil": "Privacy and profile",
  "Przeglądarka nie wspiera geolokalizacji, i brak lokalizacji domowej w profilu.": "The browser does not support geolocation and there is no home location in your profile.",
  "Przejdz do aplikacji": "Go to the app",
  "Przejdz do logowania": "Go to login",
  "Przejdź do Serwisów QSO": "Go to QSO services",
  "Przekroczono czas oczekiwania na lokalizację": "Timed out waiting for the location",
  "Przelotny deszcz": "Rain showers",
  "Przelotny deszcz gwaltowny": "Violent rain showers",
  "Przelotny deszcz slaby": "Light rain showers",
  "Przelotny snieg intensywny": "Heavy snow showers",
  "Przelotny snieg slaby": "Light snow showers",
  "Przemiennik: przesunięcie i ton ustawione": "Repeater: shift and tone set",
  "Przenieś znak/częstotliwość/emisję do loggera": "Move callsign/frequency/mode to the logger",
  "Przerwij": "Abort",
  "Przełącz": "Switch",
  "Przełącz gęstość tabeli": "Toggle table density",
  "Przełączaj pasmo razem z radiem (CAT)": "Switch band together with the radio (CAT)",
  "Przy częstej wysyłce QSO odrzucone przez QRZ (np. błędne dane) są ponawiane raz dziennie, nie co kilka minut.": "With frequent uploads, QSOs rejected by QRZ (e.g. bad data) are retried once a day, not every few minutes.",
  "Przy następnej wysyłce wyślij ponownie wszystkie QSO (np. po wyczyszczeniu logu w serwisie)": "On the next upload, resend all QSOs (e.g. after clearing the log on the service)",
  "Przybliż": "Zoom in",
  "Przybliżona lokalizacja (lokator)": "Approximate location (locator)",
  "Przykład użycia (curl):": "Usage example (curl):",
  "Przypięte": "Pinned",
  "Przypnij": "Pin",
  "Przypnij na górze menu": "Pin to the top of the menu",
  "Przypomnienie": "Reminder",
  "Przypomnij": "Remind",
  "Przyszło tylko {0} dekodów (może okno Band Activity było puste).": "Only {0} decodes arrived (maybe the Band Activity window was empty).",
  "Przywróć": "Restore",
  "Przywróć domyślne": "Restore defaults",
  "Przywróć pominięte (": "Restore skipped (",
  "Próbka:": "Sample:",
  "Prędkość": "Baud rate",
  "Prędkość (": "Speed (",
  "Prędkość i adres muszą być takie same jak w menu CAT radia. Zamknij inne programy używające portu (agent, WSJT-X, flrig).": "Baud rate and address must match the radio's CAT menu. Close other programs using the port (agent, WSJT-X, flrig).",
  "Pt": "Fri",
  "Publiczne wyszukiwanie w logu": "Public log search",
  "Pulpit": "Dashboard",
  "Punk zasilania": "Feed point",
  "Punkty za QSO z ta stacja": "Points for a QSO with this station",
  "Punkty: +{0} za wysłane zaproszenie (max {1} pkt/mies.), +{2} gdy ktoś założy konto z Twojego linku, +{3} gdy zapisze pierwsze QSO.": "Points: +{0} per invitation sent (max {1} pts/month), +{2} when someone creates an account from your link, +{3} when they log their first QSO.",
  "Pusty tekst CW": "Empty CW text",
  "Pustynia": "Desert",
  "Pytania egzaminacyjne": "Exam questions",
  "Pytania z oficjalnych materiałów UKE do egzaminu na świadectwo klasy": "Questions from the official UKE materials for the certificate exam, class",
  "Północ": "Midnight",
  "Północ u góry": "North up",
  "PĘTLA MAGNETYCZNA (MAG LOOP) — schemat techniczny (widok z przodu)": "MAGNETIC LOOP (MAG LOOP) — technical drawing (front view)",
  "Pętla sprzęgająca (~20%)": "Coupling loop (~20%)",
  "QRZ.com połączone": "QRZ.com connected",
  "QRZ.com — wyszukiwanie znaków": "QRZ.com — callsign lookup",
  "QRZ: brak danych": "QRZ: no data",
  "QRZ: {0} — dane podstawowe OK, ale brak lokatora/koordynatow nawet po geokodowaniu -- wpisano QTH jako tymczasowy lokator, popraw recznie jesli znasz prawdziwy": "QRZ: {0} — basic data OK, but no locator/coordinates even after geocoding -- the QTH was entered as a temporary locator, correct it manually if you know the real one",
  "QRZ: {0} — wykryto lokator wpisany w polu adresu ({1}), uzyto bezposrednio": "QRZ: {0} — locator found in the address field ({1}), used directly",
  "QRZ: {0} — {1} (lokalizacja orientacyjna, zgeokodowana z adresu -- QRZ nie dal wspolrzednych)": "QRZ: {0} — {1} (approximate location, geocoded from the address -- QRZ gave no coordinates)",
  "QSL otrzymana": "QSL received",
  "QSL via biuro": "QSL via bureau",
  "QSL wysłana": "QSL sent",
  "QSL wysłana: {0} · otrzymana: {1}": "QSL sent: {0} · received: {1}",
  "QSO (jeszcze nie wysłane do QRZ) -- każde QSO jest oznaczane po przetworzeniu, żeby kolejny eksport nie tworzył duplikatów. Zaznacz powyżej tylko jeśli np. przypadkowo usunąłeś swój logbook na QRZ i chcesz go odtworzyć.": "QSOs (not yet sent to QRZ) are exported -- each QSO is marked after processing so the next export does not create duplicates. Tick above only if e.g. you accidentally deleted your logbook on QRZ and want to rebuild it.",
  "QSO czekające na wysłanie (offline) — kliknij, aby zobaczyć": "QSOs waiting to be sent (offline) — click to see them",
  "QSO dodane do wspolnego dziennika!": "QSO added to the shared logbook!",
  "QSO usunięte": "QSO deleted",
  "QSO w rekordowym dniu": "QSOs on the record day",
  "QSO wcześniej": "previous QSOs",
  "QSO z": "QSO with",
  "QSO z koord.:": "QSOs with coords:",
  "QSO z {0} zalogowane — kolejka gotowa na następną stację": "QSO with {0} logged — the queue is ready for the next station",
  "QSO zaktualizowane": "QSO updated",
  "QSO zalogowane w tej sesji": "QSOs logged in this session",
  "RST odb.": "RST rcvd",
  "RST wys.": "RST sent",
  "Radia": "Radios",
  "Radio nie jest podłączone": "Radio is not connected",
  "Radio nie odpowiada — sprawdź model, prędkość i ustawienia CAT w radiu": "Radio not responding — check the model, baud rate and CAT settings in the radio",
  "Radio poza pasmami amatorskimi": "Radio is outside the amateur bands",
  "Radio przez USB (bez agenta)": "Radio over USB (no agent)",
  "Radio przez USB bez agenta działa w Chrome, Edge lub Operze na komputerze.": "Radio over USB without the agent works in Chrome, Edge or Opera on a computer.",
  "Radio przez USB bez agenta wymaga połączenia HTTPS.": "Radio over USB without the agent requires an HTTPS connection.",
  "Radiolatarnie NCDXF/IARU": "NCDXF/IARU beacons",
  "Ranking i wyzwania": "Ranking and challenges",
  "Ranking najbardziej poszukiwanych encji DXCC wg Club Log — im wyżej, tym rzadszy kraj. Przydatne, żeby wiedzieć, które DX-y warto szczególnie upolować.": "Club Log ranking of the most wanted DXCC entities — the higher, the rarer the country. Useful to know which DX are especially worth chasing.",
  "Raport": "Report",
  "Raport (RST)": "Report (RST)",
  "Raporty zależą też od propagacji i pory dnia — różnice wyjdą wiarygodnie dopiero przy kilkudziesięciu QSO na antenę na tym samym paśmie.": "Reports also depend on propagation and time of day — differences become reliable only after several dozen QSOs per antenna on the same band.",
  "Referencja parku ma postać np. SP-0123 (kilka parków rozdziel przecinkiem).": "A park reference looks like SP-0123 (separate several parks with commas).",
  "Reflektor": "Reflector",
  "Regulamin": "Terms of service",
  "Regulamin zawodów": "Contest rules",
  "Reguła zapisana": "Rule saved",
  "Reguły alertów": "Alert rules",
  "Rejestr pozwoleń": "License register",
  "Rejestracja": "Sign up",
  "Reset hasła": "Password reset",
  "Resetuj widok": "Reset view",
  "Rodzaj": "Type",
  "Rodzaj pracy: SSB — głos na falach krótkich, FM — głos na UKF (np. przez przemiennik), CW — telegrafia, FT8 — popularny tryb cyfrowy.": "The type of operation: SSB — voice on HF, FM — voice on VHF/UHF (e.g. via a repeater), CW — telegraphy, FT8 — a popular digital mode.",
  "Rok jeszcze trwa — liczby do dziś.": "The year is not over yet — numbers up to today.",
  "Rosja": "Russia",
  "Rozbłysk słoneczny od klasy M5 (R2+) — może na chwilę wygasić KF": "Solar flare of class M5 or stronger (R2+) — may briefly black out HF",
  "Rozpocznij egzamin": "Start the exam",
  "Rozpocznij eksport": "Start export",
  "Rozpocznij sesję": "Start session",
  "Rozumiem": "Got it",
  "Rozumiem, zaczynajmy": "Got it, let's start",
  "Rozwiń menu": "Expand menu",
  "Rozłącz": "Disconnect",
  "Rozłącz radio": "Disconnect radio",
  "Rozłączono QRZ.com": "QRZ.com disconnected",
  "Rura Cu/Al": "Cu/Al tube",
  "Rysunek do pytania": "Figure for the question",
  "SNR od": "SNR from",
  "SPLIT · nadawanie {0} MHz": "SPLIT · transmit {0} MHz",
  "SPLIT: nadajesz na {0} MHz — w logu: nadawanie {0}, odbiór {1}": "SPLIT: transmitting on {0} MHz — logged as TX {0}, RX {1}",
  "SSTV, sieć ratunkowa": "SSTV, emergency net",
  "Samouczek": "Tutorial",
  "Samouczek otworzysz ponownie w Ustawienia konta → Wygląd i preferencje → „Pokaż samouczek”.": "Open this tutorial again in Account settings → Appearance and preferences → “Show tutorial”.",
  "Satelita": "Satellite",
  "Schowaj parki": "Hide parks",
  "Sekcja dopasowania (λ/4)": "Matching section (λ/4)",
  "Sekcje ustawień": "Settings sections",
  "Serwer czyta klaster jako {0}": "The server reads the cluster as {0}",
  "Serwer czyta spoty z publicznych węzłów klastra, a te przyjmują tylko prawdziwe znaki (N0CALL jest odrzucany). Puste = Twój znak z SSID -9, żeby nie kolidował z Twoim własnym programem. Serwer tylko odczytuje spoty — nic nie wysyła pod tym znakiem.": "The server reads spots from public cluster nodes, which accept only real callsigns (N0CALL is rejected). Empty = your callsign with SSID -9, so it does not clash with your own program. The server only reads spots — it sends nothing under this callsign.",
  "Serwer loguje się do klastra jako N0CALL, a większość węzłów to odrzuca. Administrator ustawia znak w Panel admina → Ustawienia → „Znak logowania do klastra DX”.": "The server logs in to the cluster as N0CALL, which most nodes reject. The administrator sets a callsign in Admin panel → Settings → “DX cluster login callsign”.",
  "Serwer nie dostał jeszcze statusu": "The server has not received a status yet",
  "Serwer nie mógł wysłać e-maila — skopiuj link i wyślij go sam.": "The server could not send the email — copy the link and send it yourself.",
  "Serwis jest tymczasowo niedostepny (przerwa techniczna). Spróbuj później.": "The service is temporarily unavailable (maintenance). Try again later.",
  "Serwisy QSO": "QSO services",
  "Serwisy do wysyłki QSO": "QSO upload services",
  "Sesja": "Session",
  "Sesja QRZ wygasla -- zaloguj się ponownie (przycisk 🔑 QRZ)": "QRZ session expired -- log in again (🔑 QRZ button)",
  "Sesja QRZ wygasla -- zaloguj się ponownie, aby wyszukiwac dane operatorow": "QRZ session expired -- log in again to look up operator data",
  "Sieć (rigctld już działa gdzie indziej)": "Network (rigctld already runs elsewhere)",
  "Sieć (rotctld już działa gdzie indziej)": "Network (rotctld already runs elsewhere)",
  "Silny sygnał, czysty ton": "Strong signal, clean tone",
  "Silny wiatr i oblodzenie (prognoza na 12 h) — ryzyko dla masztu i anten": "Strong wind and icing (12 h forecast) — a risk to masts and antennas",
  "Się": "Aug",
  "Sked zaktualizowany": "Sked updated",
  "Skedy": "Skeds",
  "Skedy (umówione łączności)": "Skeds (scheduled QSOs)",
  "Skonfiguruj radio w HamLoggerze (widżet Radio → Konfiguracja radia) i sprawdź kabel/port COM.": "Configure the radio in HamLogger (Radio widget → Radio configuration) and check the cable/COM port.",
  "Skopiowano kody": "Codes copied",
  "Skopiowano link zaproszenia": "Invitation link copied",
  "Skopiowano token": "Token copied",
  "Skopiowano {0} wpisów": "Copied {0} entries",
  "Skrót: F8": "Shortcut: F8",
  "Skróty": "Shortcuts",
  "Slowacja": "Slovakia",
  "Snieg": "Snow",
  "Snieg intensywny": "Heavy snow",
  "Snieg slaby": "Light snow",
  "Sob": "Sat",
  "Specjalne": "Special",
  "Spokojny": "Calm",
  "Spot z klastra na częstotliwości radia — kliknij albo naciśnij strzałkę w dół w pustym polu znaku": "Cluster spot on the radio's frequency — click or press the down arrow in the empty callsign field",
  "Spotujacy": "Spotter",
  "Spoty": "Spots",
  "Spoty dla Ciebie": "Spots for you",
  "Sprawdz nazwe parku (waliduje referencje)": "Check the park name (validates the reference)",
  "Sprawdzam...": "Checking...",
  "Sprawdzane co ok. 5 minut (spoty z radiodyplom.pl): znak aktywatora, pasmo, emisja i nazwa akcji. Wymaga webhooka powyżej.": "Checked about every 5 minutes (spots from radiodyplom.pl): activator callsign, band, mode and award name. Requires the webhook above.",
  "Sprawdzanie...": "Checking...",
  "Sprawdź sieć i adres url w hamlogger_agent.ini.": "Check the network and the url in hamlogger_agent.ini.",
  "Sprzedam": "For sale",
  "Sprzedam / kupię / oddam": "For sale / wanted / free",
  "Stacja DX": "DX station",
  "Stan": "State",
  "Stan USA (WAS)": "US state (WAS)",
  "Standardowa": "Standard",
  "Standardowy format logow zawodowych": "Standard contest log format",
  "Stany USA:": "US states:",
  "Status (tryb, częstotliwość, TX)": "Status (mode, frequency, TX)",
  "Status WSJT-X w HamLoggerze": "WSJT-X status in HamLogger",
  "Statystyki": "Statistics",
  "Statystyki pasm": "Band statistics",
  "Sterowanie WSJT-X działa": "WSJT-X control works",
  "Sterowanie WSJT-X z HamLoggera": "WSJT-X control from HamLogger",
  "Sterowanie radiem": "Radio control",
  "Stop": "Stop",
  "Strefy CQ:": "CQ zones:",
  "Strona": "Page",
  "Strumień połączony — nowe spoty pojawią się automatycznie, gdy tylko ktoś zaspotuje stację.": "Stream connected — new spots will appear automatically as soon as someone spots a station.",
  "Strumień się łączy — spoty pojawią się za chwilę na żywo.": "Stream connecting — spots will appear live in a moment.",
  "Strumień się łączy — spoty pojawią się za chwilę na żywo. Możesz też wpisać własny znak w polu „Login\" (niektóre klastry odrzucają domyślny placeholder).": "Stream connecting — spots will appear live in a moment. You can also enter your own callsign in the “Login\" field (some clusters reject the default placeholder).",
  "Strzałki ↑↓ lub kółko myszy: strojenie (Shift = ×10), PageUp/PageDown: pasmo": "Arrows ↑↓ or mouse wheel: tune (Shift = ×10), PageUp/PageDown: band",
  "Sty": "Jan",
  "Sugestie propagacyjne": "Propagation hints",
  "Synchronizacja rejestru UKE uruchomiona": "UKE register sync started",
  "Synchronizuj teraz": "Sync now",
  "Synchronizuję…": "Syncing…",
  "Szczegóły": "Details",
  "Szczegóły i regulamin →": "Details and rules →",
  "Szczegóły na contestcalendar.com": "Details on contestcalendar.com",
  "Szczegóły techniczne": "Technical details",
  "Szczyt elementu λ/4": "Top of the λ/4 element",
  "Szukaj": "Search",
  "Szukaj (np. znak)": "Search (e.g. callsign)",
  "Szukaj parku lub znaku…": "Search for a park or callsign…",
  "Szukaj w HamQTH": "Search HamQTH",
  "Szukaj w QRZ.com (a gdy brak -- w HamQTH)": "Search QRZ.com (and HamQTH if not found)",
  "Szukaj w dzienniku": "Search the logbook",
  "Szukaj widoku albo wpisz znak (np. „dxcc”, „SP3ABC”)": "Search for a view or type a callsign (e.g. “dxcc”, “SP3ABC”)",
  "Szukaj widoku, znaku lub QSO (Ctrl+K)": "Search for a view, callsign or QSO (Ctrl+K)",
  "Szukaj widoku, znaku, QSO…": "Search for a view, callsign, QSO…",
  "Szukaj znaku, kraju, notatki…": "Search callsign, country, notes…",
  "Szukaj {0} w dzienniku": "Search {0} in the logbook",
  "Szukam radia… {0} bodów": "Looking for the radio… {0} baud",
  "Szukam…": "Searching…",
  "Szwecja": "Sweden",
  "Szybka nawigacja": "Quick navigation",
  "Szybki wybór częstotliwości": "Quick frequency picker",
  "Słucham i prowadzę dziennik nasłuchów": "I listen and keep a listening log",
  "Słyszana": "Heard",
  "Słyszana stacja": "Heard station",
  "TX włączony": "TX enabled",
  "Ta przeglądarka nie pozwala blokować wygaszania ekranu.": "This browser does not allow keeping the screen on.",
  "Ta przeglądarka nie udostępnia lokalizacji GPS.": "This browser does not provide GPS location.",
  "Ta przeglądarka nie wspiera powiadomień push.": "This browser does not support push notifications.",
  "Tabela DXCC — pasmo × emisja": "DXCC table — band × mode",
  "Tagi": "Tags",
  "Te same klawisze F7–F12 działają w trybie zawodów loggera. Tutaj nagrasz komunikaty i sprawdzisz, czy trafiają do radia.": "The same F7–F12 keys work in the logger's contest mode. Here you record messages and check that they reach the radio.",
  "Tekst CW": "CW text",
  "Tekst makra {0}:": "Macro text {0}:",
  "Tel Awiw, Izrael": "Tel Aviv, Israel",
  "Ten klawisz nie ma tekstu CW": "This key has no CW text",
  "Ten miesiąc": "This month",
  "Ten profil nie istnieje albo nie jest publiczny.": "This profile does not exist or is not public.",
  "Ten widok się nie wczytał": "This view did not load",
  "Teraz nikt nie spotuje kraju, którego Ci brakuje.": "Nobody is spotting a country you need right now.",
  "Teraz używany:": "Currently used:",
  "Teren (jasna)": "Terrain (light)",
  "Termin (UTC)": "Time (UTC)",
  "Test sterowania": "Control test",
  "Test w toku — poproszono WSJT-X o ponowne wysłanie dekodów…": "Test in progress — asked WSJT-X to resend decodes…",
  "Też warto:": "Also worth a try:",
  "To Twój dziennik łączności radiowych (log). Każda łączność to QSO — zapisujesz, z kim rozmawiałeś, kiedy, na jakiej częstotliwości i jaki był raport. W minutę pokażę Ci, gdzie co wpisać.": "This is your radio logbook (log). Every contact is a QSO — you record who you talked to, when, on which frequency and what the report was. In a minute I’ll show you what goes where.",
  "To radio nie przyjmuje tekstu CW przez CAT": "This radio does not accept CW text over CAT",
  "To radio nie przyjmuje tekstu CW przez CAT — makra CW idą tylko przez agenta.": "This radio does not accept CW text over CAT — CW macros only go through the agent.",
  "Token API": "API token",
  "Token API odwolany": "API token revoked",
  "Token odrzucony — pobierz na nowo plik .ini agenta (widżet Radio → Agent WSJT-X).": "Token rejected — download the agent .ini file again (Radio widget → WSJT-X agent).",
  "Ton (": "Tone (",
  "Ton (Hz):": "Tone (Hz):",
  "Trwale usuwa konto i wszystkie dane: QSO, nasłuchy, skedy, sieci, zapisane klucze i ustawienia. Zanim to zrobisz, pobierz kopię: Ustawienia → Konto → eksport danych albo eksport ADIF z Dziennika.": "Permanently deletes the account and all data: QSOs, SWL reports, skeds, nets, saved keys and settings. Before you do this, download a copy: Settings → Account → data export, or ADIF export from the Logbook.",
  "Tryb": "Mode",
  "Tryb WSJT-X": "WSJT-X mode",
  "Tryb debug": "Debug mode",
  "Tryb uproszczony": "Simple mode",
  "Tryb zawodów": "Contest mode",
  "Tryb:": "Mode:",
  "Tu pojawią się Twoje ostatnie łączności.": "Your latest QSOs will show up here.",
  "Tu pojawią się alerty DX, ostrzeżenia pogodowe, nowe potwierdzenia QSL, przypomnienia o zawodach i zdobyte odznaki.": "DX alerts, weather warnings, new QSL confirmations, contest reminders and earned badges will appear here.",
  "Tu są wszystkie Twoje łączności. Kliknij wiersz, żeby poprawić QSO. Możesz szukać, filtrować i eksportować log do pliku ADIF, który przyjmują inne programy i serwisy (eQSL, LoTW, QRZ).": "All your QSOs are here. Click a row to correct a QSO. You can search, filter and export the log to an ADIF file, which other programs and services accept (eQSL, LoTW, QRZ).",
  "Tune — nośna do strojenia (Alt+T)": "Tune — carrier for tuning (Alt+T)",
  "Twoj znak": "Your callsign",
  "Twoja lokalizacja:": "Your location:",
  "Twoja pozycja": "Your position",
  "Twoja ranga": "Your rank",
  "Twoje QSO z tą stacją:": "Your QSOs with this station:",
  "Twoje QTH": "Your QTH",
  "Twoje konto": "Your account",
  "Twoje miejsce: {0} z {1}.": "Your place: {0} of {1}.",
  "Twój wynik:": "Your score:",
  "Twój znak": "Your callsign",
  "Twój znak i miesięczne wyniki (QSO, CW, parki POTA, kraje DXCC) będą widoczne dla innych zalogowanych użytkowników w zakładce Społeczność → Ranking. Domyślnie wyłączone.": "Your callsign and monthly results (QSOs, CW, POTA parks, DXCC countries) will be visible to other logged-in users in Community → Ranking. Off by default.",
  "Twój znak widzą inni dopiero po włączeniu udziału w rankingach.": "Others see your callsign only after you join the rankings.",
  "Tx audio w dół (Shift+F11)": "Tx audio down (Shift+F11)",
  "Tx audio w górę (Shift+F12)": "Tx audio up (Shift+F12)",
  "Ty": "You",
  "Tylko QSO oznaczone nazwa tych zawodow (pole \"Nazwa zawodow\" w formularzu loggera)": "Only QSOs tagged with this contest name (\"Contest name\" field in the logger form)",
  "Tylko niezrobione": "Only not worked",
  "Tylko nowe kraje / pasma / emisje": "Only new countries / bands / modes",
  "Tylko to, co niezbędne: logger, dziennik, statystyki i wysyłka QSO. Chowa pasek propagacji, radio/CAT, tryb zawodów, klaster i dziesiątki dodatkowych narzędzi. Wszystkie dane zostają — wyłączysz go tutaj w każdej chwili.": "Only the essentials: logger, logbook, statistics and QSO upload. Hides the propagation bar, radio/CAT, contest mode, the cluster and dozens of extra tools. All your data stays — turn it off here at any time.",
  "Tylko znaki, z którymi nie było QSO": "Only callsigns never worked",
  "Tylko zrobione": "Only worked",
  "Typ konta": "Account type",
  "Typ konta zmienia tylko układ menu i ekran startowy — wszystkie dane zostają.": "The account type only changes the menu layout and start screen — all your data stays.",
  "Typ wymiany -- tylko podpowiada format pola, nie liczy punktow": "Exchange type -- only suggests the field format, does not score points",
  "Tytuł": "Title",
  "UTC · zmiana za": "UTC · change in",
  "Uczestników:": "Participants:",
  "Udostepniaj moja lokalizację innym użytkownikom HamLogger": "Share my location with other HamLogger users",
  "Udostepnianie lokalizacji wlaczone": "Location sharing on",
  "Udostepnianie lokalizacji wylaczone": "Location sharing off",
  "Ukraina": "Ukraine",
  "Ukryj klucz": "Hide key",
  "Układ menu": "Menu layout",
  "Ulubiona {0}": "Favourite {0}",
  "Unieważnij token i wygeneruj nowy": "Revoke the token and generate a new one",
  "Unikalne znaki": "Unique callsigns",
  "Uruchom": "Start",
  "Uruchom HamLogger_Agent.exe na komputerze przy radiu. Jeśli działa, a tu nic nie ma: pobierz nową wersję agenta": "Run HamLogger_Agent.exe on the radio PC. If it is running and nothing shows up here: download the new agent version",
  "Uruchom agenta HamLoggera i WSJT-X": "Run the HamLogger agent and WSJT-X",
  "Uruchom agenta HamLoggera i WSJT-X/JTDX na komputerze przy radiu (UDP 2237). Status pojawi się tutaj.": "Run the HamLogger agent and WSJT-X/JTDX on the radio PC (UDP 2237). The status will appear here.",
  "Urządzenie {0}": "Device {0}",
  "Ustaw": "Set",
  "Ustaw DX Call": "Set DX Call",
  "Ustaw DX Call w WSJT-X i wygeneruj komunikaty Tx1–Tx6": "Set the DX Call in WSJT-X and generate Tx1–Tx6 messages",
  "Ustaw Rx": "Set Rx",
  "Ustaw dane": "Set up",
  "Ustaw i nadaj w najbliższym okresie TX": "Set and send in the next TX period",
  "Ustaw lokalizację stacji (Ustawienia → Lokalizacja) — mapa jest wycentrowana na Twoim QTH.": "Set your station location (Settings → Location) — the map is centred on your QTH.",
  "Ustaw lokator stacji w zakładce Konto — bez niego nie wiadomo, gdzie sprawdzać burze.": "Set your station locator in the Account tab — without it we don't know where to check for storms.",
  "Ustaw nowe haslo": "Set a new password",
  "Ustawiają się same na bieżący czas. W krótkofalarstwie czas zapisuje się w UTC — w Polsce latem to 2 godziny mniej niż na zegarku, zimą 1 godzina mniej. Zmieniasz je tylko, gdy wpisujesz łączność z przeszłości.": "They are set automatically to the current time. Amateur radio uses UTC time — e.g. in Poland it is 2 hours behind the clock in summer and 1 hour in winter. Change it only when entering a past QSO.",
  "Ustawienia jak w WSJT-X (zakładka Radio) -- model, port, baud rate. Odczytywane przez lokalnego agenta CAT przy starcie. Po zmianie ustawień uruchom agenta ponownie.": "Settings as in WSJT-X (Radio tab) -- model, port, baud rate. Read by the local CAT agent at startup. Restart the agent after changing them.",
  "Ustawienia konta": "Account settings",
  "Ustawienia konta —": "Account settings —",
  "Ustawienia konta → Serwisy QSO": "Account settings → QSO services",
  "Ustawienia powiadomień": "Notification settings",
  "Usunac to QSO?": "Delete this QSO?",
  "Usunac zapisany certyfikat LoTW? Auto-upload zostanie wyłączony.": "Delete the saved LoTW certificate? Auto-upload will be turned off.",
  "Usunac {0} zaznaczonych QSO? Tej operacji nie da sie odwrocic.": "Delete {0} selected QSOs? This cannot be undone.",
  "Usunieto {0} QSO": "Deleted {0} QSOs",
  "Usunięcie konta": "Account deletion",
  "Usunięto dane: {0}": "Removed details: {0}",
  "Usunąć całą historię powiadomień?": "Delete the whole notification history?",
  "Usunąć nasłuch {0}?": "Delete the SWL report {0}?",
  "Usunąć ogłoszenie?": "Delete the listing?",
  "Usunąć profil \"{0}\"? Zapisane QSO zachowają swój sprzęt.": "Delete the profile \"{0}\"? Saved QSOs keep their equipment.",
  "Usunąć regułę „{0}”?": "Delete rule “{0}”?",
  "Usunąć sieć \"{0}\" razem z całą historią sesji i zgłoszeń?\n(QSO zapisane w logu zostaną.)": "Delete the net \"{0}\" together with all session and check-in history?\n(QSOs saved in the log will stay.)",
  "Usunąć sked z {0}?": "Delete the sked with {0}?",
  "Usunąć wiadomość?": "Delete the message?",
  "Usunąć zapisane dane logowania do {0}? Automatyczna wysyłka zostanie wyłączona.": "Remove the saved login details for {0}? Automatic upload will be turned off.",
  "Usunąć zgłoszenie {0}?{1}": "Delete check-in {0}?{1}",
  "Usuń": "Delete",
  "Usuń certyfikat": "Delete certificate",
  "Usuń dane": "Remove details",
  "Usuń konto na zawsze": "Delete the account forever",
  "Usuń konto…": "Delete account…",
  "Usuń nagranie": "Delete recording",
  "Usuń zaznaczone": "Delete selected",
  "Usłyszano przez SVXLink: {0}": "Heard via SVXLink: {0}",
  "Utwórz": "Create",
  "Uwagi": "Remarks",
  "Uzupełnia imię, QTH, lokator i kraj przy wpisywaniu znaku w loggerze. Pełne dane (lokator, współrzędne) wymagają subskrypcji QRZ „XML Logbook Data”. Sesja QRZ wygasa po ok. 24 min bez używania — wtedy połącz ponownie.": "Fills in name, QTH, locator and country as you type a callsign in the logger. Full data (locator, coordinates) requires the QRZ “XML Logbook Data” subscription. The QRZ session expires after about 24 min of inactivity — then reconnect.",
  "Uzupełniam dane (kraj, DXCC...) dla {0} QSO z QRZ.com w tle...": "Filling in data (country, DXCC...) for {0} QSOs from QRZ.com in the background...",
  "Uzupełniam dane dla {0} QSO z QRZ.com w tle...": "Filling in data for {0} QSOs from QRZ.com in the background...",
  "Uzupełnij brakujące dane (kraj, DXCC...) z QRZ.com dla wszystkich QSO bez kraju": "Fill in missing data (country, DXCC...) from QRZ.com for all QSOs without a country",
  "Uzupełnij brakujące dane (kraj, DXCC...) z QRZ.com dla zaznaczonych": "Fill in missing data (country, DXCC...) from QRZ.com for the selected QSOs",
  "Uzupełnij z QRZ": "Fill in from QRZ",
  "Użyj": "Use",
  "W WSJT-X: File → Settings → Reporting → UDP Server: 127.0.0.1, port jak w agencie (2237). Jeśli używasz też": "In WSJT-X: File → Settings → Reporting → UDP Server: 127.0.0.1, port as in the agent (2237). If you also use",
  "W WSJT-X: File → Settings → Reporting → zaznacz „Accept UDP requests”. Test wymaga dekodów w oknie Band Activity.": "In WSJT-X: File → Settings → Reporting → tick “Accept UDP requests”. The test needs decodes in the Band Activity window.",
  "W WSJT-X: Settings → Reporting → UDP Server, port": "In WSJT-X: Settings → Reporting → UDP Server, port",
  "W bazie:": "In database:",
  "W dół": "Down",
  "W górę": "Up",
  "W loggerze:": "In the logger:",
  "W menu po lewej: Log → Dziennik.": "In the menu on the left: Log → Logbook.",
  "W systemie nie ma jeszcze administratora -- po zarejestrowaniu zaloguj się, a automatycznie nim zostaniesz.": "There is no administrator yet -- after signing up, log in and you will become one automatically.",
  "W systemie nie ma jeszcze administratora -- zaloguj się, a automatycznie nim zostaniesz.": "There is no administrator yet -- log in and you will become one automatically.",
  "W toku…": "In progress…",
  "W trakcie:": "In progress:",
  "W trybie \"Port szeregowy\" agent CAT (": "In \"Serial port\" mode the CAT agent (",
  "W tym miesiącu nikt jeszcze nie zdobył punktów — możesz być pierwszy!": "Nobody has scored points this month yet — you can be the first!",
  "W. Brytania": "United Kingdom",
  "WAS wymaga pola \"Stan USA\", WAZ pola \"Zona CQ\" -- wypelniane automatycznie przez QRZ lookup gdy stacja jest z USA / ma podana zone. WPX liczony automatycznie z prefiksu znaku.": "WAS requires the \"US state\" field, WAZ the \"CQ zone\" field -- filled in automatically by the QRZ lookup when the station is in the USA / has a zone. WPX is counted automatically from the callsign prefix.",
  "WSJT-X działa, ale nie przysłał jeszcze żadnego dekodu.": "WSJT-X is running but has not sent any decode yet.",
  "WSJT-X gotowy": "WSJT-X ready",
  "WSJT-X i agent": "WSJT-X and agent",
  "WSJT-X nadaje": "WSJT-X transmitting",
  "WSJT-X nie odpowiedział na test": "WSJT-X did not answer the test",
  "WSJT-X niepołączony": "WSJT-X not connected",
  "WSJT-X połączony": "WSJT-X connected",
  "WSJT-X ucichł": "WSJT-X went quiet",
  "WSJT-X wyłączony w agencie": "WSJT-X disabled in the agent",
  "WSJT-X — pilot": "WSJT-X remote",
  "WSJT-X: wołam {0} ({1})": "WSJT-X: calling {0} ({1})",
  "WSJT-X: wołam {0}…": "WSJT-X: calling {0}…",
  "Warszawa": "Warsaw",
  "Warunek wg Twojego logu": "Condition based on your log",
  "Warunki": "Conditions",
  "Warunki propagacji, antena, uwagi...": "Propagation conditions, antenna, remarks...",
  "Watchlista jest pusta": "The watchlist is empty",
  "Wavelog i Cloudlog to logi webowe na własnym serwerze (Twoim albo klubu). Klucz API z prawem zapisu utworzysz w Wavelog: Konto → API Keys. ID profilu stacji: Station Locations (liczba w kolumnie ID).": "Wavelog and Cloudlog are web logs on your own server (yours or your club's). Create an API key with write access in Wavelog: Account → API Keys. Station profile ID: Station Locations (number in the ID column).",
  "Ważna aktywacja POTA to min. 10 QSO w jednym dniu UTC.": "A valid POTA activation needs at least 10 QSOs in one UTC day.",
  "Wczytuję…": "Loading…",
  "Webhook (Discord)": "Webhook (Discord)",
  "Webhook (np. Discord) ustawisz w Ustawienia → Powiadomienia.": "Set up a webhook (e.g. Discord) in Settings → Notifications.",
  "Webhook Discord": "Discord webhook",
  "Webhook Discord zapisany -- alerty z watchlisty będą teraz wysylane na Discord": "Discord webhook saved -- watchlist alerts will now be sent to Discord",
  "Webhook zapisany": "Webhook saved",
  "Wersja aplikacji — kliknij, aby zobaczyć listę zmian": "App version — click to see the changelog",
  "Wersja {0} · działa od {1}": "Version {0} · running for {1}",
  "Weryfikacja Email": "E-mail verification",
  "Wgraj": "Upload",
  "Wgraj MASTER.SCP": "Upload MASTER.SCP",
  "Wgraj go na pota.app: menu konta → Log Uploads → Upload Log. POTA nie udostępnia wysyłki z innych programów, więc ten krok robisz na ich stronie.": "Upload it on pota.app: account menu → Log Uploads → Upload Log. POTA does not allow uploads from other programs, so this step is done on their website.",
  "Wgraj przez TQSL": "Upload via TQSL",
  "Wgrano bazę Super Check Partial: {0} znaków": "Super Check Partial database uploaded: {0} callsigns",
  "Wiadomości{0}": "Messages{0}",
  "Wiadomość do {0}…": "Message to {0}…",
  "Wiadomość wysłana": "Message sent",
  "Wiersz pasma, na którym": "The row of the band on which",
  "Wiosna": "Spring",
  "Witaj w HamLoggerze!": "Welcome to HamLogger!",
  "Więcej": "More",
  "Więcej motywów (": "More themes (",
  "Więcej szczegółów": "More details",
  "Więcej: dekodowanie, konfiguracja, lokator, podświetlanie": "More: decoding, configuration, locator, highlighting",
  "Wklej tu link webhooka swojego kanalu Discord -- alerty z watchlisty (wszystkie, bez osobnego checkboxa) będą wysylane jako kolorowe \"embedy\". Działa również ze Slack (URL webhooka z ustawien kanalu) -- wtedy alerty wysylane są jako tekst.": "Paste your Discord channel webhook link here -- watchlist alerts (all of them, no separate checkbox) will be sent as coloured \"embeds\". Also works with Slack (webhook URL from the channel settings) -- then alerts are sent as text.",
  "Wlaczenie tej opcji pozwoli innym operatorom HamLoggera znaleźć Cie w wyszukiwarce sąsiedztwa (widoczny będzie tylko Twój znak, odległość i przybliżona pozycja na mapie — bez adresu czy danych osobowych). Wymagane do korzystania z wyszukiwarki w obie strony.": "Turning this on lets other HamLogger operators find you in the neighbour search (only your callsign, distance and approximate position on the map are shown — no address or personal data). Required to use the search in both directions.",
  "Wodospad SE": "Waterfall SE",
  "Województwa: sprawdzam jeszcze lokalizację {0} QSO z polskimi stacjami — wynik uzupełni się w ciągu kilkunastu minut.": "Voivodeships: still checking the location of {0} QSOs with Polish stations — the result will update within a few minutes.",
  "Wolny tekst (13 zn.)": "Free text (13 chars)",
  "Wolny tekst (13 znaków)": "Free text (13 characters)",
  "Wpisz klucz QRZ Logbook API": "Enter the QRZ Logbook API key",
  "Wpisz raport z S-metra radia (szczyt z ostatnich 5 s): {0}": "Fill in the report from the radio's S-meter (peak of the last 5 s): {0}",
  "Wpisz swoje współrzędne, wybierz satelitę i kliknij „Śledź\".": "Enter your coordinates, choose a satellite and click “Track\".",
  "Wpisz swój znak (": "Enter your callsign (",
  "Wpisz tekst do nadania": "Enter text to send",
  "Wpisz tekst do nadania (np. CQ CQ DE SQ3TR)": "Enter text to send (e.g. CQ CQ DE SQ3TR)",
  "Wpisz w megahercach (MHz), np. 7.100 albo 145.500. Pasmo (40m, 2m…) HamLogger policzy sam i pokaże obok.": "Enter it in megahertz (MHz), e.g. 7.100 or 145.500. HamLogger works out the band (40m, 2m…) and shows it next to it.",
  "Wpisz znak i częstotliwość": "Enter the callsign and frequency",
  "Wpisz znak wywoławczy stacji, z którą rozmawiałeś, np. SP1ABC. Wielkie litery wstawią się same. Jeśli połączysz konto QRZ.com albo HamQTH, imię i miejscowość (QTH) uzupełnią się automatycznie.": "Enter the callsign of the station you talked to, e.g. SP1ABC. Capital letters are added automatically. If you connect a QRZ.com or HamQTH account, the name and location (QTH) fill in automatically.",
  "Wpisz znak, a tu pojawi się karta stacji: kto to jest, skąd, odległość, wcześniejsze QSO i aktualne spoty.": "Type a callsign and the station card appears here: who it is, where from, distance, previous QSOs and current spots.",
  "Wrz": "Sep",
  "Wrzuć oba pliki do": "Put both files into",
  "Wróć": "Back",
  "Wróć do loggera": "Back to the logger",
  "Wskazówki, NIE precyzyjna predykcja -- oparte na realnych danych słonecznych (hamqsl.com) i faktycznej pozycji Słońca względem Ciebie i każdego regionu. Przeglądarka poprosi o zgodę na lokalizację, żeby to policzyć.": "Hints, NOT a precise prediction -- based on real solar data (hamqsl.com) and the actual position of the Sun relative to you and each region. The browser will ask for location permission to calculate this.",
  "Wstaw ostatnie słowo jako znak": "Insert the last word as the callsign",
  "Wstawiono \"{0}\" do pola znaku": "Inserted \"{0}\" into the callsign field",
  "Wstecz": "Back",
  "Wszechstronność": "Versatility",
  "Wszystkie": "All",
  "Wszystkie QSO mają już uzupełniony kraj": "All QSOs already have a country",
  "Wszystkie działy": "All sections",
  "Wszystkie emisje": "All modes",
  "Wszystkie inne sesje zostaly wylogowane.": "All other sessions have been logged out.",
  "Wszystkie kafelki są wyłączone — włącz je przyciskiem „Dostosuj”.": "All tiles are turned off — turn them on with the “Customize” button.",
  "Wszystkie kategorie": "All categories",
  "Wszystkie kraje": "All countries",
  "Wszystkie kraje DXCC": "All DXCC countries",
  "Wszystkie nowe (kraje, pasma, znaki)": "All new (countries, bands, callsigns)",
  "Wszystkie pasma": "All bands",
  "Wszystkie tagi": "All tags",
  "Wszystkie zdarzenia": "All events",
  "Wszystkie źródła": "All sources",
  "Wszystko": "All",
  "Wt": "Tue",
  "Wybierz plik PDF": "Choose PDF file",
  "Wybierz plik certyfikatu (.tq6)": "Choose the certificate file (.tq6)",
  "Wybierz plik certyfikatu (.tq6) albo podaj login do lotw.arrl.org": "Choose a certificate file (.tq6) or enter your lotw.arrl.org login",
  "Wybrany kierunek": "Selected direction",
  "Wyczysc": "Clear",
  "Wyczyszczenie okien": "Window clear",
  "Wyczyść": "Clear",
  "Wyczyść okna dekodów": "Clear the decode windows",
  "Wygenerowac nowy token? Stary przestanie działać natychmiast (skrypty go uzywajace trzeba będzie zaktualizowac).": "Generate a new token? The old one will stop working immediately (scripts using it will need updating).",
  "Wygenerowano nowy token API": "New API token generated",
  "Wygenerowano przez": "Generated by",
  "Wygeneruj token API": "Generate API token",
  "Wygląd i preferencje": "Appearance and preferences",
  "Wygląd zapisuje się w tej przeglądarce — na innym urządzeniu ustawisz go osobno.": "Appearance is saved in this browser — set it separately on other devices.",
  "Wyjście audio (podłączone do radia)": "Audio output (connected to the radio)",
  "Wykryj radio automatycznie": "Detect the radio automatically",
  "Wykryto radio: {0}, {1} bodów": "Radio detected: {0}, {1} baud",
  "Wylogowac sie?": "Log out?",
  "Wylogowac wszystkie inne sesje (na wszystkich urzadzeniach)? Ta sesja pozostanie zalogowana.": "Log out all other sessions (on all devices)? This session stays logged in.",
  "Wyloguj": "Log out",
  "Wyloguj wszystkie inne sesje": "Log out all other sessions",
  "Wymaga agenta HamLoggera 1.61+ na Windows (skróty klawiszowe WSJT-X)": "Requires HamLogger agent 1.61+ on Windows (WSJT-X keyboard shortcuts)",
  "Wymaga agenta HamLoggera 1.62+ na Windows (skróty klawiszowe WSJT-X)": "Requires HamLogger agent 1.62+ on Windows (WSJT-X keyboard shortcuts)",
  "Wymagane konto QRZ.com z aktywna platna subskrypcja \"XML Logbook Data\" (osobny dodatek, nie samo Premium Membership) -- bez niej dane podstawowe (adres, kraj) działają, ale lokator/koordynaty (lat/lon/grid) nie będą zwracane przez QRZ.": "Requires a QRZ.com account with an active paid \"XML Logbook Data\" subscription (a separate add-on, not just Premium Membership) -- without it basic data (address, country) works, but QRZ will not return the locator/coordinates (lat/lon/grid).",
  "Wymagane: znak i częstotliwość": "Required: callsign and frequency",
  "Wymagane: znak, częstotliwość, emisja": "Required: callsign, frequency, mode",
  "Wymagania nieznane — sprawdź regulamin na stronie akcji": "Requirements unknown — check the rules on the activity page",
  "Wymagany klucz QRZ Logbook API": "QRZ Logbook API key required",
  "Wymiana odebrana": "Exchange received",
  "Wymiana wysłana": "Exchange sent",
  "Wymiana:": "Exchange:",
  "Wymus swieze pobranie (pomija 5-min cache)": "Force a fresh download (skips the 5-min cache)",
  "Wymuś pobranie najnowszej wersji": "Force download of the latest version",
  "Wynik": "Score",
  "Wypelniono z radia: {0} MHz / {1}": "Filled in from the radio: {0} MHz / {1}",
  "Wypowiedz znak alfabetem fonetycznym, np. 'Sierra Papa One Alpha Bravo Charlie' (eksperymentalne)": "Say the callsign using the phonetic alphabet, e.g. 'Sierra Papa One Alpha Bravo Charlie' (experimental)",
  "Wyslano do ClubLog! ({0} QSO)": "Sent to ClubLog! ({0} QSOs)",
  "Wyslano do HRDLOG.net! ({0} QSO)": "Sent to HRDLOG.net! ({0} QSOs)",
  "Wyslano do LoTW! ({0} QSO)": "Sent to LoTW! ({0} QSOs)",
  "Wyslano do eQSL.cc! ({0} QSO)": "Sent to eQSL.cc! ({0} QSOs)",
  "Wyslano link weryfikacyjny": "Verification link sent",
  "Wyslij eQSL dla zaznaczonych QSO": "Send eQSL for the selected QSOs",
  "Wysoki kontrast": "High contrast",
  "Wysyłam do WSJT-X: {0}…": "Sending to WSJT-X: {0}…",
  "Wysyłam…": "Uploading…",
  "Wysyłane są tylko nowe QSO (maks. 300 na raz — reszta przy kolejnej wysyłce). Duplikaty w Wavelog są pomijane. Adres w sieci lokalnej (np. 10.x/192.168.x) może ustawić tylko administrator serwera.": "Only new QSOs are sent (max. 300 at a time — the rest with the next upload). Duplicates in Wavelog are skipped. A local network address (e.g. 10.x/192.168.x) can only be set by the server administrator.",
  "Wysyłane są tylko nowe QSO — jeśli nic nie przybyło, nie ma żadnego zapytania do serwisu.": "Only new QSOs are sent — if nothing new was added, no request is made to the service.",
  "Wysyłane są tylko nowe QSO. Dane logowania i klucze API ustawiasz w": "Only new QSOs are uploaded. Login details and API keys are set in",
  "Wysyłka QSO do serwisów": "Uploading QSOs to services",
  "Wysyłka do serwisów": "Upload to services",
  "Wysyłka eQSL wystartowała dla {0} QSO": "eQSL sending started for {0} QSOs",
  "Wyszukiwanie znaku w loggerze (imię, QTH, lokator, e-mail do eQSL) bez płatnej subskrypcji QRZ. Używane automatycznie, gdy nie jesteś zalogowany do QRZ albo QRZ nie zna znaku. Konto zakładasz za darmo na hamqth.com.": "Callsign lookup in the logger (name, QTH, locator, e-mail for eQSL) without a paid QRZ subscription. Used automatically when you are not logged in to QRZ or QRZ does not know the callsign. Create a free account at hamqth.com.",
  "Wysłana": "Sent",
  "Wysłane do WSJT-X": "Sent to WSJT-X",
  "Wysłane zaproszenia": "Sent invitations",
  "Wysłano do Wavelog: {0} QSO{1}": "Sent to Wavelog: {0} QSOs{1}",
  "Wysłano do {0}: {1} QSO{2}": "Uploaded to {0}: {1} QSO{2}",
  "Wysłano link weryfikacyjny": "Verification link sent",
  "Wysłać do publicznej sieci klastrów DX?\n\nDX de {0}:  {1}  {2}  {3}": "Send to the public DX cluster network?\n\nDX de {0}:  {1}  {2}  {3}",
  "Wyłącz": "Turn off",
  "Wyłącz na tym urządzeniu": "Turn off on this device",
  "Wyłącz split": "Turn split off",
  "Wyślij": "Send",
  "Wyślij do wszystkich ({0})": "Upload to all ({0})",
  "Wyślij eQSL": "Send eQSL",
  "Wyślij eQSL ręcznie": "Send eQSL manually",
  "Wyślij link weryfikacyjny": "Send verification link",
  "Wyślij ponownie WSZYSTKIE QSO (nawet już wcześniej wysłane)": "Resend ALL QSOs (even those sent before)",
  "Wyślij ponownie link": "Resend link",
  "Wyślij spot tej stacji na klaster DX (pod Twoim znakiem)": "Send a spot of this station to the DX cluster (under your callsign)",
  "Wyślij zaproszenie": "Send invitation",
  "Wzmacniacz": "Amplifier",
  "Wznów": "Resume",
  "Węzeł klastra odrzucił spot: {0}": "The cluster node rejected the spot: {0}",
  "Włochy": "Italy",
  "Włącz powiadomienia push": "Turn on push notifications",
  "Włącz tryb uproszczony (minimum opcji)": "Turn on simple mode (minimum options)",
  "Włącz udostepnianie lokalizacji powyzej, aby wyszukac operatorow w okolicy": "Turn on location sharing above to search for operators nearby",
  "Włącz w Prywatność i profil": "Turn it on in Privacy and profile",
  "Włączenie zapisze się przy pierwszej ręcznej wysyłce (z zapamiętaniem danych).": "The setting is saved with the first manual upload (with remembered credentials).",
  "Włączona": "Enabled",
  "Włączony Monitor? Radio na paśmie z ruchem FT8/FT4?": "Is Monitor on? Is the radio on a band with FT8/FT4 activity?",
  "YAGI 3-ELEMENTOWY — schemat techniczny (rzut z góry / plan)": "3-ELEMENT YAGI — technical drawing (top view / plan)",
  "Z kim": "With whom",
  "Z niepotwierdzonymi slotami": "With unconfirmed slots",
  "Z radia": "From radio",
  "Z ustawien konta ClubLog": "From your ClubLog account settings",
  "ZAPISZ QSO": "LOG QSO",
  "ZNAK": "CALL",
  "Za dużo zapytań -- spróbuj za minutę.": "Too many requests -- try again in a minute.",
  "Za godzinę": "In an hour",
  "Zablokowane w ustawieniach przeglądarki -- odblokuj ręcznie, żeby włączyć.": "Blocked in the browser settings -- unblock it manually to turn it on.",
  "Zachód słońca": "Sunset",
  "Zacznij (20 pytań)": "Start (20 questions)",
  "Zaczynam pracę": "Start logging",
  "Zaczynamy": "Let’s start",
  "Zadziałał watchdog TX — WSJT-X wyłączył nadawanie.": "The TX watchdog fired — WSJT-X turned transmitting off.",
  "Zaimportowano potwierdzenia": "Confirmations imported",
  "Zaimportowano:": "Imported:",
  "Zakończ aktywację — wyślij log do POTA": "Finish the activation — send the log to POTA",
  "Zakończ i sprawdź": "Finish and check",
  "Zakończyć egzamin i sprawdzić wynik?": "Finish the exam and check the result?",
  "Zakończyć sesję? Możesz dodać notatkę (opcjonalnie):": "End the session? You can add a note (optional):",
  "Zaktualizowano {0} QSO": "Updated {0} QSOs",
  "Zaladowano aktywacje WWFF: {0}{1}": "WWFF activation loaded: {0}{1}",
  "Zaladowano aktywacje: {0} @ {1}": "Activation loaded: {0} @ {1}",
  "Zaladowano spot: {0} @ {1} MHz": "Spot loaded: {0} @ {1} MHz",
  "Zaladowano: {0}": "Loaded: {0}",
  "Zaladowano: {0}{1}": "Loaded: {0}{1}",
  "Zaliczone!": "Completed!",
  "Zaliczony dziś": "Worked today",
  "Zalogowal": "Logged by",
  "Zalogowane QSO": "Logged QSOs",
  "Zalogowane QSO (ADIF)": "Logged QSOs (ADIF)",
  "Zalogowano do QRZ.com!": "Logged in to QRZ.com!",
  "Zaloguj QSO z tym aktywatorem": "Log a QSO with this activator",
  "Zaloguj QSO z {0}": "Log a QSO with {0}",
  "Zamień stacje miejscami": "Swap stations",
  "Zamknij": "Close",
  "Zamknięcie WSJT-X": "WSJT-X closed",
  "Zapamiętaj (klucz zaszyfrowany na serwerze)": "Remember (key encrypted on the server)",
  "Zapamiętaj dane (hasło zaszyfrowane na serwerze)": "Remember credentials (password encrypted on the server)",
  "Zapamiętaj klucz": "Remember key",
  "Zapisane też jako QSO w logu": "Also saved as a QSO in the log",
  "Zapisane — wpisz, by zmienić": "Saved — type to change",
  "Zapisano": "Saved",
  "Zapisano dane: {0}": "Saved details: {0}",
  "Zapisany certyfikat: {0}": "Saved certificate: {0}",
  "Zapisany klucz kończy się na: {0}": "The saved key ends with: {0}",
  "Zapisany klucz ma zły format (prawdopodobnie przeglądarka wpisała tu hasło) — wpisz klucz QRZ Logbook ponownie.": "The saved key has a wrong format (the browser probably filled in a password here) — enter the QRZ Logbook key again.",
  "Zapisany — wpisz nowy tylko, by go zmienić": "Saved — enter a new one only to change it",
  "Zapisuj każde zgłoszenie też jako QSO w moim logu": "Also save every check-in as a QSO in my log",
  "Zapisuje się na koncie (także język maili). Domyślnie: polski dla polskich znaków (SP, SQ, SN, SO, SR, 3Z, HF), angielski dla pozostałych.": "Saved on your account (also used for emails). Default: Polish for Polish callsigns (SP, SQ, SN, SO, SR, 3Z, HF), English for all others.",
  "Zapisuję…": "Saving…",
  "Zapisz": "Save",
  "Zapisz e-mail": "Save e-mail",
  "Zapisz lokalizację": "Save location",
  "Zapisz tu dane logowania i klucze API. Wysyłkę i harmonogram automatycznej wysyłki ustawisz w widoku „Wyślij do serwisów”. Hasła i klucze są zaszyfrowane na serwerze i nie są nigdzie wyświetlane.": "Save your login details and API keys here. Uploading and the automatic upload schedule are in the “Upload to services” view. Passwords and keys are encrypted on the server and never displayed.",
  "Zapisz zmiany": "Save changes",
  "Zapomnialem hasła": "I forgot my password",
  "Zaproszenie wysłane na {0}": "Invitation sent to {0}",
  "Zaproś krótkofalowca": "Invite a radio amateur",
  "Zaproś znajomych": "Invite friends",
  "Zasilacz": "Power supply",
  "Zasilanie (λ/4 koax 75 Ω)": "Feed (λ/4 coax 75 Ω)",
  "Zatrzymaj nadawanie i wyłącz Enable TX": "Stop transmitting and turn Enable TX off",
  "Zawody i dyplomy (WAS, WAZ, POTA, SOTA)": "Contests and awards (WAS, WAZ, POTA, SOTA)",
  "Zaznacz pasma, na których możesz nadawać, i maksymalną moc. Logger ostrzeże, gdy wpiszesz częstotliwość lub moc poza nimi. Nic nie zaznaczone = bez sprawdzania pasm.": "Select the bands you may transmit on and your maximum power. The logger will warn you when you enter a frequency or power outside them. Nothing selected = no band check.",
  "Zaznacz wszystkie": "Select all",
  "Zaznacz {0}": "Select {0}",
  "Zaznaczone QSO nie potrzebują uzupełnienia": "The selected QSOs do not need filling in",
  "Zaznaczone motywy ta stacja zobaczy w Ustawienia konta → Wygląd, nawet jeśli normalnie są zastrzeżone (np. YouTube) albo przeznaczone dla innego kraju. Stacja dostanie powiadomienie.": "This station will see the selected themes in Account settings → Appearance, even if they are normally restricted (e.g. YouTube) or meant for another country. The station will get a notification.",
  "Zbieram informacje…": "Gathering information…",
  "Zdarzenia bezpieczeństwa: logowania, blokady, zmiany haseł i 2FA, tokeny, usunięcia kont. Przechowywane": "Security events: logins, lockouts, password and 2FA changes, tokens, account deletions. Kept for",
  "Zdarzenie": "Event",
  "Zdekodowany tekst pojawi się tutaj. Skieruj mikrofon na źródło dźwięku CW i dostrój suwak „Ton\" do wysokości piszczenia (zwykle 600–700 Hz).": "Decoded text will appear here. Point the microphone at the CW sound source and tune the “Tone\" slider to the pitch of the beep (usually 600–700 Hz).",
  "Zdekodowany tekst pojawi się tutaj...": "Decoded text will appear here...",
  "Zdjęcia (do 4, zmniejszane automatycznie)": "Photos (up to 4, resized automatically)",
  "Zdobyte: {0} z {1}": "Earned: {0} of {1}",
  "Zdobądź pierwsze punkty, żeby pojawić się w rankingu.": "Score your first points to appear in the ranking.",
  "Zgłoszeń": "Check-ins",
  "Ziemia": "Ground",
  "Zima": "Winter",
  "Zmiana częstotliwości idzie przez CAT agenta (rigctld). Żeby WSJT-X podążał za radiem, ustaw w nim Radio: „Hamlib NET rigctl”, Network Server: localhost:4532.": "Frequency changes go through the agent’s CAT (rigctld). For WSJT-X to follow the radio, set Radio: “Hamlib NET rigctl”, Network Server: localhost:4532 in WSJT-X.",
  "Zmiana hasła": "Change password",
  "Zmierzch": "Dusk",
  "Zmień": "Change",
  "Zmień hasło": "Change password",
  "Zmień tryb…": "Change mode…",
  "Znak": "Callsign",
  "Znak (np. 3B9FR lub SP*)": "Callsign (e.g. 3B9FR or SP*)",
  "Znak / Login QRZ": "QRZ callsign / login",
  "Znak / e-mail": "Callsign / e-mail",
  "Znak DX": "DX callsign",
  "Znak jej korespondenta. Jeśli stacja wołała ogólnie, wpisz CQ.": "The callsign of its partner. If the station was calling in general, enter CQ.",
  "Znak korespondenta": "Their callsign",
  "Znak korespondenta (do makra": "Other station's callsign (for macro",
  "Znak logowania do klastra DX": "DX cluster login callsign",
  "Znak stacji": "Station callsign",
  "Znak stacji na...": "Station callsign at...",
  "Znak stacji, którą usłyszałeś, np. JA1XYZ.": "The callsign of the station you heard, e.g. JA1XYZ.",
  "Znak uzywany do logowania w klastrze DX -- opcjonalny, domyślnie N0CALL": "Callsign used to log in to the DX cluster -- optional, N0CALL by default",
  "Znak wywoławczy, logger QSO": "Callsign, QSO logger",
  "Znak, dla ktorego wystawiono certyfikat": "Callsign the certificate was issued for",
  "Znak, np. DL3NEW": "Callsign, e.g. DL3NEW",
  "Znaki (z *, po przecinku)": "Callsigns (with *, comma separated)",
  "Zobacz regulamin →": "See the rules →",
  "Zona CQ (WAZ)": "CQ zone (WAZ)",
  "Zorza": "Aurora",
  "Zostaw puste, aby uzyc zapisanego": "Leave empty to use the saved one",
  "Zostaw puste, aby użyć zapisanego": "Leave empty to use the saved one",
  "Zrobione i minione (ostatnie 7 dni)": "Done and past (last 7 days)",
  "Zrodlo WWFF chwilowo niedostepne": "The WWFF source is temporarily unavailable",
  "Zsynchronizowano: +{0} nowych, {1} zaktualizowanych": "Synced: +{0} new, {1} updated",
  "Zwiń menu": "Collapse menu",
  "Zwiń menu do ikon": "Collapse menu to icons",
  "Zwolnij": "Release",
  "[wsjtx] enabled = false w hamlogger_agent.ini": "[wsjtx] enabled = false in hamlogger_agent.ini",
  "aktywacji": "activations",
  "aktywator": "activator",
  "aktywny": "active",
  "aktywnych": "active",
  "aktywnych · dane: WWFF Spotline (publiczne) · odświeżanie co 60s": "active · data: WWFF Spotline (public) · refreshed every 60s",
  "albo wybierz ręcznie:": "or choose manually:",
  "albo własny PDF:": "or your own PDF:",
  "allow_tx_control = false — działa podgląd, Stop TX, tryb i podświetlanie.": "allow_tx_control = false — preview, Stop TX, mode and highlighting work.",
  "allow_tx_control = true — „Odpowiedz” i F8 w kolejce Live Roster wywołują nadawanie.": "allow_tx_control = true — “Reply” and F8 in the Live Roster queue start transmitting.",
  "auto": "auto",
  "automatycznie": "automatic",
  "bez CAT": "no CAT",
  "bez limitu": "no limit",
  "bez nowych krajów": "no new countries",
  "brak": "none",
  "brak QSO w tych zawodach": "no QSOs in this contest",
  "brak danych": "not set up",
  "brak pasujących": "no matches",
  "brakujące kraje": "needed countries",
  "cień = noc (aktualizowana co 5 min)": "shadow = night (updated every 5 min)",
  "co 15 min": "every 15 min",
  "co 30 min": "every 30 min",
  "co 5 min": "every 5 min",
  "co godzinę": "every hour",
  "czasu lokalnego": "local time",
  "cze": "Jun",
  "czerwiec": "June",
  "czyść": "clear",
  "dekody i szczegóły": "decodes and details",
  "dla kraju \"{0}\"": "for country \"{0}\"",
  "dla tego wyszukiwania": "for this search",
  "dla wybranych filtrów": "for the selected filters",
  "dni (adres IP to dane osobowe).": "days (IP addresses are personal data).",
  "dni w eterze": "days on the air",
  "do (UTC)": "to (UTC)",
  "do potwierdzenia": "to confirm",
  "do powtórki": "to review",
  "do rangi „{0}”: {1} pkt": "to the “{0}” rank: {1} pts",
  "dołączył": "joined",
  "dołączyło": "joined",
  "dzień": "day",
  "dzień / noc": "day / night",
  "dzień wcześniej i ": "the day before and ",
  "dzisiaj na tym paśmie/modzie!": "today on this band/mode!",
  "dzisiaj na tym paśmie/modzie:": "today on this band/mode:",
  "eQSL (zaznaczone)": "eQSL (selected)",
  "eQSL nie wysłane": "eQSL not sent",
  "eQSL odpowiedzialo bledem -- sprawdź dane logowania": "eQSL returned an error -- check your login details",
  "eQSL wysłane": "eQSL sent",
  "eQSL wysłane {0}": "eQSL sent {0}",
  "eQSL.cc, ClubLog, QRZ Logbook, LoTW i Wavelog — logowanie do serwisów i automatyczna wysyłka są w widoku „Wyślij do serwisów”.": "eQSL.cc, ClubLog, QRZ Logbook, LoTW and Wavelog — logging in to the services and automatic upload are in the “Upload to services” view.",
  "flrig jako pośrednik.": "flrig as an intermediary.",
  "folderu": "folder",
  "gru": "Dec",
  "grudzień": "December",
  "imię, QTH, lokator, QSL, POTA/SOTA, zawody, notatki": "name, QTH, locator, QSL, POTA/SOTA, contests, notes",
  "jeden": "one",
  "jednocześnie": "at the same time",
  "jeszcze nie": "not yet",
  "już przerobionych": "already done",
  "już wcześniej wysłanych QSO": "QSOs already sent before",
  "każdym": "each",
  "km z wlaczonym udostepnianiem lokalizacji": "km with location sharing on",
  "koax 50 Ω": "coax 50 Ω",
  "kolega@example.com": "friend@example.com",
  "krajów": "countries",
  "krajów (RBN)": "countries (RBN)",
  "krajów potwierdzonych": "countries confirmed",
  "krajów zrobionych": "countries worked",
  "kwi": "Apr",
  "kwiecień": "April",
  "linia 450 Ω": "450 Ω line",
  "lip": "Jul",
  "lipiec": "July",
  "lis": "Nov",
  "listopad": "November",
  "lok. ·": "loc. ·",
  "lokalnie": "local",
  "lut": "Feb",
  "luty": "February",
  "maj": "May",
  "mar": "Mar",
  "marzec": "March",
  "min na dział, zaliczenie działu od": "min per section, a section is passed from",
  "min temu": "min ago",
  "min. 6 znaków": "min. 6 characters",
  "na": "on",
  "na Telegramie → /newbot → skopiuj token": "on Telegram → /newbot → copy the token",
  "na Twoim komputerze -- HamLogger nie może zrobić tego za Ciebie (certyfikat nigdy nie opuszcza Twojego komputera, i tak ma być). To jest asystent tego procesu.": "on your computer -- HamLogger cannot do this for you (the certificate never leaves your computer, and that is how it should be). This is an assistant for that process.",
  "nad horyzontem": "above the horizon",
  "nadaje teraz, jest podświetlony; w kolumnie „Następna” widać, za ile sekund pojawi się na pozostałych pasmach.": "is transmitting now is highlighted; the “Next” column shows in how many seconds it will appear on the other bands.",
  "najaktywniejszy miesiąc": "most active month",
  "najdalej": "farthest",
  "najdalej: {0}": "farthest: {0}",
  "najdalsze QSO": "farthest QSO",
  "najdłuższa seria: {0} dni z rzędu": "longest streak: {0} days in a row",
  "nasłuchów ·": "SWL reports ·",
  "nie wysłano": "not sent",
  "niepotwierdzony": "unconfirmed",
  "niepołączono": "not connected",
  "niepołączony": "not connected",
  "nieprzeczytane": "unread",
  "nieznany błąd": "unknown error",
  "nowa emisja": "new mode",
  "nowe": "new",
  "nowe pasmo": "new band",
  "nowy kraj": "new country",
  "nowy park": "new park",
  "nowych krajów": "new countries",
  "np. 16.13": "e.g. 16.13",
  "np. 22": "e.g. 22",
  "np. 52.32": "e.g. 52.32",
  "np. 6": "e.g. 6",
  "np. A1B2C3D4": "e.g. A1B2C3D4",
  "np. ABCD-0A0B-1C1D-2E2F": "e.g. ABCD-0A0B-1C1D-2E2F",
  "np. Dom — EFHW": "e.g. Home — EFHW",
  "np. EFHW 40–10 m": "e.g. EFHW 40–10 m",
  "np. IC-7300": "e.g. IC-7300",
  "np. JO82FX": "e.g. JO82FX",
  "np. Jan Kowalski SQ3TR": "e.g. John Smith SQ3TR",
  "np. Japan albo JA": "e.g. Japan or JA",
  "np. Klub SP3PWR": "e.g. Club SP3PWR",
  "np. Loguję tu wszystkie QSO, spróbuj — 73!": "e.g. I log all my QSOs here, give it a try — 73!",
  "np. Nowe kraje 20m CW": "e.g. New countries 20m CW",
  "np. PL-1234": "e.g. PL-1234",
  "np. SP-0123": "e.g. SP-0123",
  "np. SP1ABC Contest Team": "e.g. SP1ABC Contest Team",
  "np. SP9-1234": "e.g. SP9-1234",
  "np. Siec klubowa SP5KAB": "e.g. Club net SP5KAB",
  "np. VP8*, 3Y0J": "e.g. VP8*, 3Y0J",
  "np. bardzo dobry": "e.g. very good",
  "np. każdy czwartek 20:00 lokalnego": "e.g. every Thursday 20:00 local time",
  "np. ma korespondencję": "e.g. has traffic",
  "np. odbiornik, antena, warunki": "e.g. receiver, antenna, conditions",
  "np. sp5xyz@example.com": "e.g. sp5xyz@example.com",
  "np. test anteny, QSY na 40 m jeśli brak propagacji": "e.g. antenna test, QSY to 40 m if no propagation",
  "o czasie": "on time",
  "obecna": "current",
  "odbiór": "receiving",
  "offline — zapis lokalny": "offline — saving locally",
  "online": "online",
  "opanowanych": "mastered",
  "ostatnie 30 min": "last 30 min",
  "parametry": "parameters",
  "parków": "parks",
  "parków POTA": "POTA parks",
  "pasm": "bands",
  "paź": "Oct",
  "październik": "October",
  "pkt": "pts",
  "pkt w tym miesiącu": "pts this month",
  "pod horyzontem": "below the horizon",
  "podpisy znaków": "callsign labels",
  "pokaż wszystkie parki": "show all parks",
  "popularne częstotliwości, przemienniki, ulubione": "popular frequencies, repeaters, favourites",
  "potwierdzenia": "confirmations",
  "potwierdzone": "confirmed",
  "potwierdzone (LoTW/QSL) ·": "confirmed (LoTW/QSL) ·",
  "potwierdzony": "confirmed",
  "potwierdzony (LoTW/QSL)": "confirmed (LoTW/QSL)",
  "poziom {0}/{1}": "level {0}/{1}",
  "połączono": "connected",
  "program. Gdy flrig jest jedynym właścicielem portu, fldigi, WSJT-X i HamLogger mogą korzystać z radia": "program. When flrig is the only owner of the port, fldigi, WSJT-X and HamLogger can use the radio",
  "przed chwilą": "just now",
  "przejdź": "go",
  "przemienniki.eu/eksport-danych": "przemienniki.eu/eksport-danych",
  "przeskok(ów)": "hop(s)",
  "puste = darmowa mapa terenu Esri": "empty = free Esri terrain map",
  "puste = do negocjacji": "empty = negotiable",
  "pytań do nauki": "questions to study",
  "pytań z każdego działu,": "questions from each section,",
  "raport": "report",
  "raz dziennie": "once a day",
  "roku.": ".",
  "różnych stacji": "different stations",
  "ręcznie": "manual",
  "segment CW i wąskich emisji cyfrowych": "CW and narrow digital modes segment",
  "segment emisji wąskopasmowych (bez FM)": "narrowband modes segment (no FM)",
  "segment radiolatarni": "beacon segment",
  "segment tylko CW": "CW-only segment",
  "serwis odpowiedział błędem": "the service returned an error",
  "sesja wygasła": "session expired",
  "sierpień": "August",
  "się": "Aug",
  "slotów (kraj+pasmo+emisja)": "slots (country+band+mode)",
  "slotów potwierdzonych": "slots confirmed",
  "spotow": "spots",
  "stacji Cię słyszało": "stations heard you",
  "stan nie podano": "condition not given",
  "stany USA": "US states",
  "status:": "status:",
  "strefy CQ": "CQ zones",
  "sty": "Jan",
  "styczeń": "January",
  "tego samego": "the same",
  "test": "test",
  "tu jesteś": "you are here",
  "tutaj (żeby nie eksportować ich ponownie):": "here (so they are not exported again):",
  "tylko nowe parki": "only new parks",
  "u góry": "at the top",
  "ukryj zaliczone dziś": "hide worked today",
  "ulubiona godzina (UTC)": "favourite hour (UTC)",
  "użytkowników (dane zanonimizowane, zsumowane)": "users (anonymised, aggregated data)",
  "w TQSL (Sign and upload), który podpisze go i wyśle do LoTW.": "in TQSL (Sign and upload), which signs it and sends it to LoTW.",
  "w logu. Sprawdź pisownię znaku albo spróbuj później -- log mógł jeszcze nie zostać wgrany.": "in the log. Check the callsign spelling or try later -- the log may not have been uploaded yet.",
  "w sekcji [wsjtx] — tylko gdy nadzorujesz stację.": "in the [wsjtx] section — only when you supervise the station.",
  "w sekcji [wsjtx].": "in the [wsjtx] section.",
  "w tej chwili": "right now",
  "w zasięgu": "in range",
  "watchlista": "watchlist",
  "ważne do {0}": "valid until {0}",
  "wiadomość usunięta": "message deleted",
  "wrz": "Sep",
  "wrzesień": "September",
  "wszystkie pasma": "all bands",
  "wybór": "select",
  "wygasło {0}": "expired {0}",
  "wysłane": "sent",
  "wysłanych": "sent",
  "wyłączony": "off",
  "włączony": "on",
  "z QSO do wysłania:": "of QSOs to send:",
  "z pięciu pasm. Górne liczby to kraje na danym paśmie.": "of five bands. The top numbers are countries per band.",
  "z powyzszych stacji uczestniczy w biezacych akcjach dyplomowych": "of the stations above take part in current award activities",
  "za": "in",
  "za radiem": "follow radio",
  "zaliczony": "worked",
  "zamknij": "close",
  "zamknięte": "closed",
  "zapis ·": "save ·",
  "zapisane": "saved",
  "zapisanych offline — wysłać do bazy?": "saved offline — send to the database?",
  "zdobyte": "earned",
  "zgłoszeń": "check-ins",
  "znaków": "callsigns",
  "znaków ·": "callsigns ·",
  "zrobione · klik = lista QSO": "worked · click = QSO list",
  "zrobiony": "worked",
  "{0} -- kliknij prawym/długo aby edytować": "{0} -- right-click/long-press to edit",
  "{0} -- użyto lokalizacji domowej z profilu.": "{0} -- using the home location from your profile.",
  "{0} MHz jest poza przydziałem pasma {1} w Regionie 1 ({2}–{3} MHz).": "{0} MHz is outside the {1} band allocation in Region 1 ({2}–{3} MHz).",
  "{0} MHz to {1} (IARU R1) — nie nadawaj tutaj.": "{0} MHz is a {1} (IARU R1) — do not transmit here.",
  "{0} błędnych wpisów odrzucono": "{0} invalid entries rejected",
  "{0} czestotliwosci · IARU Region 1/2/3 Band Plan": "{0} frequencies · IARU Region 1/2/3 Band Plan",
  "{0} dekodów · ostatni {1}": "{0} decodes · last {1}",
  "{0} duplikatów pominięto": "{0} duplicates skipped",
  "{0} duplikatów pominięto (już masz je w logu)": "{0} duplicates skipped (you already have them in your log)",
  "{0} godz. temu": "{0} h ago",
  "{0} m (bok)  obwód: {1} m": "{0} m (side)  perimeter: {1} m",
  "{0} m (całość)": "{0} m (total)",
  "{0} m (dłuższe)": "{0} m (longer)",
  "{0} m (krótsze)": "{0} m (shorter)",
  "{0} m — całkowita (1.25 λ, ramię 0.625 λ)": "{0} m — total (1.25 λ, arm 0.625 λ)",
  "{0} m — całkowita długość": "{0} m — total length",
  "{0} min przed": "{0} min before",
  "{0} min temu": "{0} min ago",
  "{0} na {1} MHz: to {2} wg planu IARU Region 1.": "{0} on {1} MHz: this is a {2} according to the IARU Region 1 band plan.",
  "{0} pkt": "{0} pts",
  "{0} przemienników · źródło: przemienniki.eu": "{0} repeaters · source: przemienniki.eu",
  "{0} różnych stacji": "{0} different stations",
  "{0} ulubionych czestotliwosci": "{0} favourite frequencies",
  "{0} zaprasza Cię do HamLoggera — załóż konto poniżej.": "{0} invites you to HamLogger — create your account below.",
  "{0} zł": "{0} PLN",
  "{0} · {1} kHz · {2}\n{3} — {4}\n{5} (de {6}, {7})": "{0} · {1} kHz · {2}\n{3} — {4}\n{5} (de {6}, {7})",
  "{0}, i brak lokalizacji domowej w profilu -- nie można policzyć sugestii.": "{0}, and no home location in your profile -- cannot calculate hints.",
  "{0}: odblokowane motywy — {1}": "{0}: unlocked themes — {1}",
  "{0}: wysłano pierwszą partię — resztę wyślij ponownie (albo poczekaj na automatyczną wysyłkę).": "{0}: the first batch was sent — send again for the rest (or wait for the automatic upload).",
  "{0}:00 — Ty: {1}": "{0}:00 — you: {1}",
  "{0}:00 — społeczność (średnio): {1}": "{0}:00 — community (average): {1}",
  "{0}{1} -- rozważ odłączenie anteny": "{0}{1} -- consider disconnecting the antenna",
  "°, długość": "°, longitude",
  "· (włącz udział, by zobaczyć miejsce)": "· (turn on participation to see your place)",
  "· blisko terminatora (greyline) -- dobry moment na dolne pasma!": "· near the terminator (greyline) -- a good time for the low bands!",
  "· błąd:": "· error:",
  "· cisza {0}–{1} UTC": "· quiet {0}–{1} UTC",
  "· do {0}": "· until {0}",
  "· emisje:": "· modes:",
  "· klik w spot = QSY": "· click a spot = QSY",
  "· makra:": "· macros:",
  "· miejsce {0} z {1}": "· place {0} of {1}",
  "· odpowiedzi": "· answers",
  "· ostatnie": "· last",
  "· pierwsze": "· first",
  "· pokazano {0} najnowszych": "· showing the {0} newest",
  "· spotowany {0}×": "· spotted {0}×",
  "· wynik": "· score",
  "· zaliczonych: {0}": "· worked: {0}",
  "· zapis do pliku": "· logging to file",
  "· śledzenie na żywo": "· live tracking",
  "· ⏳ trwa…": "· ⏳ running…",
  "Ładowanie widoku…": "Loading view…",
  "Ładowanie...": "Loading...",
  "Ładowanie…": "Loading…",
  "Łączności": "Contacts",
  "Łączności ogółem": "Total QSOs",
  "Łączności wg dnia tygodnia": "QSOs by day of week",
  "Łączności wg godziny UTC": "QSOs by UTC hour",
  "Łączności wg miesiąca": "QSOs by month",
  "łączenie…": "connecting…",
  "łączności": "QSOs",
  "Śledzę radio": "Following radio",
  "Śledzę radio: {0} MHz / {1} -- kliknij, żeby wyłączyć": "Following the radio: {0} MHz / {1} -- click to turn off",
  "Śledź radiolatarnię": "Track a beacon",
  "Śr": "Wed",
  "Śr. km": "Avg. km",
  "Śr. raport S": "Avg. S report",
  "Śr. raport dB": "Avg. dB report",
  "Średni raport otrzymany (S z RST) — fonia/CW": "Average report received (S from RST) — phone/CW",
  "Średni raport otrzymany w dB — FT8/FT4": "Average report received in dB — FT8/FT4",
  "Średni użytkownik (społeczność)": "Average user (community)",
  "Średnia odległość od Twojego QTH (tylko QSO z lokalizacją)": "Average distance from your QTH (only QSOs with a location)",
  "Źródła spotów": "Spot sources",
  "Źródło": "Source",
  "Źródło Clublog chwilowo niedostepne z serwera": "The Clublog source is temporarily unavailable from the server",
  "Źródło: WWFF Spotline (publiczne API)": "Source: WWFF Spotline (public API)",
  "Źródło: przemienniki.eu": "Source: przemienniki.eu",
  "Źródło: radiodyplom.pl": "Source: radiodyplom.pl",
  "Źródło: {0}": "Source: {0}",
  "źródło:": "source:",
  "— bez konfliktu o COM.": "— no fight over the COM port.",
  "— bez profilu —": "— no profile —",
  "— czekam na zalogowanie QSO": "— waiting for the QSO to be logged",
  "— dodaj pierwsze.": "— add the first one.",
  "— eQSL.cc, ClubLog i QRZ Logbook mogą wysyłać nowe łączności same, raz dziennie (zakładka eQSL/ClubLog/QRZ, opcja \"zapamiętaj i wysyłaj automatycznie\").": "— eQSL.cc, ClubLog and QRZ Logbook can upload new QSOs on their own, once a day (eQSL/ClubLog/QRZ tab, \"remember and upload automatically\" option).",
  "— mało! Rozważ ponowną konfigurację, aby wygenerować nowe.": "— running low! Consider setting it up again to generate new ones.",
  "— obserwuj znaki/kraje/aktywacje POTA i dostawaj powiadomienie w przeglądarce, nawet gdy karta jest zamknięta.": "— watch callsigns/countries/POTA activations and get a browser notification, even when the tab is closed.",
  "— poza jasnym/ciemnym są też Spokojny, XP, Vista, Terminal i Neon, a menu można ustawić z boku ekranu (Ustawienia konta → Wygląd).": "— besides light/dark there are also Calm, XP, Vista, Terminal and Neon, and the menu can be placed on the side of the screen (Account settings → Appearance).",
  "— radio i antena zapiszą się przy każdym QSO, a potem porównasz anteny.": "— the radio and antenna are saved with every QSO, and later you can compare antennas.",
  "— sprawdź czy to nie przypadkowy duplikat.": "— check that it is not an accidental duplicate.",
  "„Odpowiedz na CQ” działa, gdy stacja woła CQ i jej dekod jest w oknie Band Activity. Do stacji, która nie woła CQ: ustaw DX Call, a potem Enable TX.": "“Reply to CQ” works when the station is calling CQ and its decode is in the Band Activity window. For a station not calling CQ: set the DX Call, then Enable TX.",
  "ℹ️ Pominięto": "ℹ️ Skipped",
  "← Poprz.": "← Prev.",
  "← Wroc do listy": "← Back to the list",
  "← Wroc do logowania": "← Back to login",
  "← Wróć": "← Back",
  "← Wszystkie sesje": "← All sessions",
  "↳ Wstaw": "↳ Insert",
  "↺ Odnów (60 dni)": "↺ Renew (60 days)",
  "↺ Teraz": "↺ Now",
  "↻ Odswiez": "↻ Refresh",
  "↻ Odśwież": "↻ Refresh",
  "↻ Synchronizuj teraz": "↻ Sync now",
  "⏱ początek QSO": "⏱ QSO start",
  "⏳ Eksport w toku:": "⏳ Export in progress:",
  "⏳ Laczenie z klastrem...": "⏳ Connecting to the cluster...",
  "⏳ Liczę...": "⏳ Counting...",
  "⏳ Liczę…": "⏳ Counting…",
  "⏳ pobieram listę parków (pierwsze uruchomienie)…": "⏳ downloading the park list (first run)…",
  "⏳ Ładowanie akcji dyplomowych...": "⏳ Loading award activities...",
  "⏳ Ładowanie postepu w dyplomach...": "⏳ Loading award progress...",
  "⏳ Ładowanie spotów...": "⏳ Loading spots...",
  "⏳ Ładowanie...": "⏳ Loading...",
  "⏸ Zatrzymaj": "⏸ Stop",
  "⏹ Zakończ sesję": "⏹ End session",
  "⏹ Zatrzymaj": "⏹ Stop",
  "⏺ Zatrzymaj": "⏺ Stop",
  "▴ ukryj braki": "▴ hide missing",
  "▾ brakuje {0}": "▾ {0} missing",
  "○ łączenie...": "○ connecting...",
  "● NADAWANIE — kliknij, żeby puścić": "● TRANSMITTING — click to release",
  "☀️ dzień": "☀️ day",
  "⚠️ Adres email nie zostal potwierdzony": "⚠️ E-mail address not confirmed",
  "⚠️ Brak spotów.": "⚠️ No spots.",
  "⚠️ Część QSO z kolejki offline NIE wysłała się (serwer odrzucił): {0}. Kliknij ikonę 📴 w nagłówku, żeby zobaczyć szczegóły i usunąć/poprawić.": "⚠️ Some QSOs from the offline queue were NOT sent (the server rejected them): {0}. Click the 📴 icon in the header to see details and delete/fix them.",
  "⚠️ Działa TYLKO jeśli masz aktywną płatną usługę": "⚠️ Works ONLY if you have the active paid service",
  "⚠️ Już masz QSO z": "⚠️ You already have a QSO with",
  "⚠️ LoTW wymaga podpisania QSO Twoim certyfikatem przez program": "⚠️ LoTW requires signing QSOs with your certificate using the program",
  "⚠️ Masz już QSO z": "⚠️ You already have a QSO with",
  "⚠️ Nieudana próba usunięcia konta": "⚠️ Failed account deletion attempt",
  "⚠️ Ostatnia automatyczna wysyłka nie powiodła się:": "⚠️ The last automatic upload failed:",
  "⚠️ QSO zapisywane pod": "⚠️ QSOs are saved under",
  "⚠️ Wyłączono 2FA": "⚠️ 2FA disabled",
  "⚠️ błąd ładowania parków": "⚠️ error loading parks",
  "⚠️ {0} -- profil QRZ sugeruje, że to może być Silent Key (zmarły krótkofalowiec). Sprawdź, zanim zalogujesz.": "⚠️ {0} -- the QRZ profile suggests this may be a Silent Key (deceased radio amateur). Check before logging.",
  "⚪ cisza": "⚪ silence",
  "⛈️ Burza": "⛈️ Storm",
  "⛔ Blokada IP": "⛔ IP blocked",
  "⛔ Próba na zablokowane konto": "⛔ Attempt on a locked account",
  "⛔ blokady IP": "⛔ IP blocks",
  "✅ Egzamin zdany!": "✅ Exam passed!",
  "✅ Logowanie": "✅ Login",
  "✅ Potwierdzone": "✅ Confirmed",
  "✅ Włączone": "✅ On",
  "✅ Zakończono! Wysłano:": "✅ Done! Sent:",
  "✅ logowania": "✅ logins",
  "✅ zdany": "✅ passed",
  "✉️ Prośba o reset hasła": "✉️ Password reset request",
  "✓ Hasło zostalo zmienione!": "✓ Password changed!",
  "✓ Konto HamQTH zapisane — wyszukiwanie znaków działa też bez QRZ (odśwież stronę)": "✓ HamQTH account saved — callsign lookup also works without QRZ (refresh the page)",
  "✓ Masz go w logu": "✓ You have it in your log",
  "✓ Sprzedane": "✓ Sold",
  "✓ Zaliczony dziś": "✓ Worked today",
  "✓ Zapisane konto:": "✓ Saved account:",
  "✓ Zapisz (Enter)": "✓ Save (Enter)",
  "✓ Zapisz konfigurację": "✓ Save configuration",
  "✓ Zaznaczono": "✓ Selected",
  "✓ {0} w logu": "✓ {0} logged",
  "✕ Odznacz": "✕ Deselect",
  "❌ Brak QSO": "❌ No QSO",
  "❌ Egzamin niezdany": "❌ Exam failed",
  "❌ Nieudane logowanie": "❌ Failed login",
  "❌ nieudane": "❌ failed",
  "❌ niezdany": "❌ failed",
  "⬇ Eksportuj": "⬇ Export",
  "⭐ Nowy park dla Ciebie": "⭐ New park for you",
  "🌍 Ogólny": "🌍 General",
  "🌍 Ty vs Społeczność — kiedy ludzie robią QSO na 20m?": "🌍 You vs the community — when do people make QSOs on 20m?",
  "🌙 noc": "🌙 night",
  "🍪 Ta aplikacja korzysta z localStorage/IndexedDB do logowania i działania offline -- bez śledzenia, reklam czy analityki.": "🍪 This app uses localStorage/IndexedDB for login and offline mode -- no tracking, ads or analytics.",
  "🎉 10 QSO — aktywacja {0} jest ważna!": "🎉 10 QSOs — activation {0} is valid!",
  "🎉 Nowy mnożnik!": "🎉 New multiplier!",
  "🎙️ Fonia: nagrania na wybrane wyjście audio": "🎙️ Phone: recordings to the selected audio output",
  "🎙️ Nagraj": "🎙️ Record",
  "🎙️ Sesja": "🎙️ Session",
  "🎛️ Sprzęt:": "🎛️ Equipment:",
  "🎤 Rozpoznano: {0}": "🎤 Recognised: {0}",
  "🎤 Start nasluchu": "🎤 Start listening",
  "🎧 {0} zapisany": "🎧 {0} saved",
  "🎨 Motywy i układ menu": "🎨 Themes and menu layout",
  "🎬 Pierwsze QSO:": "🎬 First QSO:",
  "🎭 Działasz jako": "🎭 You are acting as",
  "🎯 Śledź": "🎯 Track",
  "🏆 Rekordy osobiste (dystans)": "🏆 Personal records (distance)",
  "👋 Witaj w HamLoggerze!": "👋 Welcome to HamLogger!",
  "💡 Dekoder działa najlepiej przy czystym, jednostajnym sygnale. Szum, QSB i nierówne nadawanie ręczne obniżają skuteczność — to normalne ograniczenie każdego automatycznego dekodera CW. Cała analiza odbywa się lokalnie w Twojej przeglądarce; dźwięk nie jest nigdzie wysyłany.": "💡 The decoder works best with a clean, steady signal. Noise, QSB and uneven hand keying reduce accuracy — a normal limitation of any automatic CW decoder. All analysis happens locally in your browser; the audio is not sent anywhere.",
  "💡 Metoda Kocha: zacznij od 2 znaków przy docelowej prędkości (np. 20 WPM), dodawaj kolejny dopiero przy ~90% skuteczności. Farnsworth wydłuża odstępy, więc słyszysz znaki od razu w docelowym tempie. Dźwięk generowany lokalnie.": "💡 Koch method: start with 2 characters at the target speed (e.g. 20 WPM) and add the next one only at ~90% accuracy. Farnsworth lengthens the gaps so you hear characters at the target speed from the start. Sound generated locally.",
  "💡 Uczciwe porównanie anten wymaga wybrania jednego pasma.": "💡 A fair antenna comparison requires choosing a single band.",
  "📅 Sked z {0} zapisany": "📅 Sked with {0} saved",
  "📊 Frekwencja": "📊 Attendance",
  "📊 Porównanie": "📊 Comparison",
  "📜 Historia": "📜 History",
  "📜 Regulamin": "📜 Terms of service",
  "📝 Lista zmian": "📝 Changelog",
  "📝 Otwarto formularz QSO -- uzupełnij znak i pozostałe dane": "📝 QSO form opened -- fill in the callsign and the rest of the data",
  "📡 CW przez keyer radia (agent CAT)": "📡 CW via the radio keyer (CAT agent)",
  "📡 Wyslano {0} QSO z kolejki offline": "📡 Sent {0} QSOs from the offline queue",
  "📢 Spot wysłany: {0} {1} kHz (jako {2})": "📢 Spot sent: {0} {1} kHz (as {2})",
  "📤 Auto-wysyłka QSO": "📤 Automatic QSO upload",
  "📤 Uplink (skorygowany)": "📤 Uplink (corrected)",
  "📥 Downlink (skorygowany)": "📥 Downlink (corrected)",
  "📧 Wyślij eQSL": "📧 Send eQSL",
  "📴 Brak połączenia -- QSO zapisane offline, wysle się automatycznie": "📴 No connection -- QSO saved offline, it will be sent automatically",
  "📴 Masz": "📴 You have",
  "📴 {0} zapisane offline — wyśle się po powrocie sieci": "📴 {0} saved offline — it will be sent when the network is back",
  "📻 Nowe QSO: {0} ({1} {2})": "📻 New QSO: {0} ({1} {2})",
  "📻 Ostatnie QSO:": "📻 Latest QSO:",
  "📻 QSY wysłane: {0} MHz ({1}) -- zadziała jeśli masz uruchomiony agent CAT": "📻 QSY sent: {0} MHz ({1}) -- works if the CAT agent is running",
  "📻 Radio (USB) nastawione: {0} MHz ({1})": "📻 Radio (USB) tuned: {0} MHz ({1})",
  "📻 Radio (USB) nastawione: {0} MHz{1}": "📻 Radio (USB) tuned: {0} MHz{1}",
  "📻 Radio (USB): przemiennik {0} MHz, przesunięcie {1} kHz{2}": "📻 Radio (USB): repeater {0} MHz, shift {1} kHz{2}",
  "📻 Radio (USB): {0} MHz{1}, SPLIT — nadawanie {2} MHz": "📻 Radio (USB): {0} MHz{1}, SPLIT — transmit {2} MHz",
  "📻 Wyslano QSY: {0} MHz{1} -- jeśli masz uruchomiony agent CAT, radio przestawi się automatycznie": "📻 QSY sent: {0} MHz{1} -- if the CAT agent is running, the radio will retune automatically",
  "📻 radio niepodłączone (agent CAT)": "📻 radio not connected (CAT agent)",
  "🔁 Automatyczna wysyłka włączona": "🔁 Automatic upload on",
  "🔁 Wysyłaj nowe QSO automatycznie": "🔁 Upload new QSOs automatically",
  "🔍 Szukaj znaku...": "🔍 Search callsign...",
  "🔍 kraj lub prefiks": "🔍 country or prefix",
  "🔍 szukaj…": "🔍 search…",
  "🔍 znak, e-mail lub IP": "🔍 callsign, e-mail or IP",
  "🔑 Reset hasła": "🔑 Password reset",
  "🔑 Zaloguj": "🔑 Log in",
  "🔑 Zmiana hasła": "🔑 Password change",
  "🔒 Klucz zapisany — wpisz nowy tylko, by go zmienić": "🔒 Key saved — enter a new one only to change it",
  "🔒 Konto zablokowane (za dużo prób)": "🔒 Account locked (too many attempts)",
  "🔒 blokady kont": "🔒 account lockouts",
  "🔔 Watchlist + powiadomienia push": "🔔 Watchlist + push notifications",
  "🔔 wysłane": "🔔 sent",
  "🔔 {0} min przed": "🔔 {0} min before",
  "🔕 Powiadomienia push są wyłączone w tej przeglądarce — przypomnienie nie dotrze. Włącz je w zakładce Watchlist (przycisk powiadomień push).": "🔕 Push notifications are off in this browser — the reminder will not arrive. Turn them on in the Watchlist tab (push notifications button).",
  "🔧 Nowy token API": "🔧 New API token",
  "🔧 Nowy token agenta": "🔧 New agent token",
  "🔧 Odwołano token API": "🔧 API token revoked",
  "🔴 Aktywny teraz:": "🔴 Active now:",
  "🔴 Brak agenta": "🔴 No agent",
  "🔴 Sesja trwa od": "🔴 Session running since",
  "🔴 trwa": "🔴 running",
  "🕐 na zywo": "🕐 live",
  "🗑️ Usunięcie konta": "🗑️ Account deletion",
  "🚪 Wyloguj wszędzie": "🚪 Log out everywhere",
  "🚫 Logowanie na zawieszone konto": "🚫 Login to a suspended account",
  "🛠️ Zostałeś automatycznie ustawiony jako pierwszy administrator systemu! Zakładka \"Admin\" jest już dostępna w menu.": "🛠️ You have been automatically set up as the first system administrator! The \"Admin\" tab is now available in the menu.",
  "🛡️ Włączono 2FA": "🛡️ 2FA enabled",
  "🟢 Połączono": "🟢 Connected",
  "🟢 Połączono live": "🟢 Live connected",
  "🟢 USB (przeglądarka)": "🟢 USB (browser)",
  "🧭 Mam obrotnicę anteny (rotor) podłączoną do tego komputera": "🧭 I have an antenna rotator connected to this computer",
  "🧭 Obrotnica (USB): obrót na {0}°": "🧭 Rotator (USB): turning to {0}°",
  "🧭 Obrót wysłany: {0}° -- zadziała jeśli masz uruchomiony agent z obrotnicą": "🧭 Rotation sent: {0}° -- works if the agent with the rotator is running",
  "🧭 Wysłano obrót anteny na {0}° (agent rotora)": "🧭 Antenna rotation to {0}° sent (rotator agent)",
};

export default EN_TEXTS;
